/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as appRouteRouteImport } from './routes/(app)/route'
import { Route as appIndexRouteImport } from './routes/(app)/index'
import { Route as unauthenticatedTermsRouteImport } from './routes/(unauthenticated)/terms'
import { Route as unauthenticatedSignupRouteImport } from './routes/(unauthenticated)/signup'
import { Route as unauthenticatedOrganizationSelectorIndexRouteImport } from './routes/(unauthenticated)/organization-selector/index'
import { Route as unauthenticatedLinkIdentityIndexRouteImport } from './routes/(unauthenticated)/link-identity/index'
import { Route as appProfileIndexRouteImport } from './routes/(app)/profile/index'
import { Route as appOrgIndexRouteImport } from './routes/(app)/org/index'
import { Route as appInvitesIndexRouteImport } from './routes/(app)/invites/index'
import { Route as unauthenticatedOrganizationsStartRouteImport } from './routes/(unauthenticated)/organizations/start'
import { Route as unauthenticatedLinkIdentityCallbackRouteImport } from './routes/(unauthenticated)/link-identity/callback'
import { Route as unauthenticatedOrganizationsInvitesRouteRouteImport } from './routes/(unauthenticated)/organizations/invites/route'
import { Route as appOrgOrgRouteRouteImport } from './routes/(app)/org/$org/route'
import { Route as appOrgOrgIndexRouteImport } from './routes/(app)/org/$org/index'
import { Route as unauthenticatedOrganizationsInvitesAcceptRouteImport } from './routes/(unauthenticated)/organizations/invites/accept'
import { Route as appIntegrationsJiraCallbackRouteImport } from './routes/(app)/integrations/jira/callback'
import { Route as unauthenticatedPublishedV1SwimlaneRouteRouteImport } from './routes/(unauthenticated)/published/v1/swimlane/route'
import { Route as appOrgOrgTeamsRouteRouteImport } from './routes/(app)/org/$org/teams/route'
import { Route as appOrgOrgSettingsRouteRouteImport } from './routes/(app)/org/$org/settings/route'
import { Route as appOrgOrgRoadmapsRouteRouteImport } from './routes/(app)/org/$org/roadmaps/route'
import { Route as appOrgOrgPortfolioRouteRouteImport } from './routes/(app)/org/$org/portfolio/route'
import { Route as appOrgOrgInsightsRouteRouteImport } from './routes/(app)/org/$org/insights/route'
import { Route as appOrgOrgIdeaManagementRouteRouteImport } from './routes/(app)/org/$org/idea-management/route'
import { Route as appOrgOrgContributorsRouteRouteImport } from './routes/(app)/org/$org/contributors/route'
import { Route as appOrgOrgAdaptivePlannerRouteRouteImport } from './routes/(app)/org/$org/adaptive-planner/route'
import { Route as unauthenticatedOrganizationsInvitesErrorIndexRouteImport } from './routes/(unauthenticated)/organizations/invites/error/index'
import { Route as appOrgOrgTeamsIndexRouteImport } from './routes/(app)/org/$org/teams/index'
import { Route as appOrgOrgSettingsIndexRouteImport } from './routes/(app)/org/$org/settings/index'
import { Route as appOrgOrgRoadmapsIndexRouteImport } from './routes/(app)/org/$org/roadmaps/index'
import { Route as appOrgOrgPortfolioIndexRouteImport } from './routes/(app)/org/$org/portfolio/index'
import { Route as appOrgOrgInsightsIndexRouteImport } from './routes/(app)/org/$org/insights/index'
import { Route as appOrgOrgIdeaManagementIndexRouteImport } from './routes/(app)/org/$org/idea-management/index'
import { Route as appOrgOrgContributorsIndexRouteImport } from './routes/(app)/org/$org/contributors/index'
import { Route as appOrgOrgAdaptivePlannerIndexRouteImport } from './routes/(app)/org/$org/adaptive-planner/index'
import { Route as appOrgOrgIdeaManagementPriorityFrameworksRouteImport } from './routes/(app)/org/$org/idea-management/priority-frameworks'
import { Route as appOrgOrgIdeaManagementOverviewRouteImport } from './routes/(app)/org/$org/idea-management/overview'
import { Route as appOrgOrgIdeaManagementCustomFieldsRouteImport } from './routes/(app)/org/$org/idea-management/custom-fields'
import { Route as appOrgOrgSettingsUserManagementRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/route'
import { Route as appOrgOrgSettingsRolesRouteRouteImport } from './routes/(app)/org/$org/settings/roles/route'
import { Route as appOrgOrgSettingsOrganizationRouteRouteImport } from './routes/(app)/org/$org/settings/organization/route'
import { Route as appOrgOrgSettingsConnectionsRouteRouteImport } from './routes/(app)/org/$org/settings/connections/route'
import { Route as appOrgOrgSettingsCapacityRouteRouteImport } from './routes/(app)/org/$org/settings/capacity/route'
import { Route as appOrgOrgRoadmapsRoadmapIdRouteRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/route'
import { Route as appOrgOrgIdeaManagementPortalsRouteRouteImport } from './routes/(app)/org/$org/idea-management/portals/route'
import { Route as appOrgOrgIdeaManagementInboxRouteRouteImport } from './routes/(app)/org/$org/idea-management/inbox/route'
import { Route as unauthenticatedPublishedV1SwimlaneLinkIdIndexRouteImport } from './routes/(unauthenticated)/published/v1/swimlane/$linkId/index'
import { Route as appOrgOrgTeamsMembersIndexRouteImport } from './routes/(app)/org/$org/teams/members/index'
import { Route as appOrgOrgSettingsUserManagementIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/index'
import { Route as appOrgOrgSettingsSubscriptionsIndexRouteImport } from './routes/(app)/org/$org/settings/subscriptions/index'
import { Route as appOrgOrgSettingsSkillsIndexRouteImport } from './routes/(app)/org/$org/settings/skills/index'
import { Route as appOrgOrgSettingsRolesIndexRouteImport } from './routes/(app)/org/$org/settings/roles/index'
import { Route as appOrgOrgSettingsOrganizationIndexRouteImport } from './routes/(app)/org/$org/settings/organization/index'
import { Route as appOrgOrgSettingsLocationIndexRouteImport } from './routes/(app)/org/$org/settings/location/index'
import { Route as appOrgOrgSettingsItemTypesIndexRouteImport } from './routes/(app)/org/$org/settings/item-types/index'
import { Route as appOrgOrgSettingsIntegrationsIndexRouteImport } from './routes/(app)/org/$org/settings/integrations/index'
import { Route as appOrgOrgSettingsEffortEstimationIndexRouteImport } from './routes/(app)/org/$org/settings/effort-estimation/index'
import { Route as appOrgOrgSettingsCustomItemStatusIndexRouteImport } from './routes/(app)/org/$org/settings/custom-item-status/index'
import { Route as appOrgOrgSettingsCustomFieldsIndexRouteImport } from './routes/(app)/org/$org/settings/custom-fields/index'
import { Route as appOrgOrgSettingsConnectionsIndexRouteImport } from './routes/(app)/org/$org/settings/connections/index'
import { Route as appOrgOrgSettingsCapacityIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/index'
import { Route as appOrgOrgSettingsBoxesIndexRouteImport } from './routes/(app)/org/$org/settings/boxes/index'
import { Route as appOrgOrgRoadmapsRoadmapIdIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/index'
import { Route as appOrgOrgPortfolioTableIndexRouteImport } from './routes/(app)/org/$org/portfolio/table/index'
import { Route as appOrgOrgInsightsProgressIndexRouteImport } from './routes/(app)/org/$org/insights/progress/index'
import { Route as appOrgOrgInsightsInvestmentBalanceIndexRouteImport } from './routes/(app)/org/$org/insights/investment-balance/index'
import { Route as appOrgOrgIdeaManagementProductAreasIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/index'
import { Route as appOrgOrgIdeaManagementPortalsIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/index'
import { Route as appOrgOrgIdeaManagementInboxIndexRouteImport } from './routes/(app)/org/$org/idea-management/inbox/index'
import { Route as appOrgOrgIdeaManagementIdeasIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/index'
import { Route as appOrgOrgIdeaManagementCustomersIndexRouteImport } from './routes/(app)/org/$org/idea-management/customers/index'
import { Route as appOrgOrgContributorsContributorIdIndexRouteImport } from './routes/(app)/org/$org/contributors/$contributorId/index'
import { Route as unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRouteImport } from './routes/(unauthenticated)/published/v1/swimlane/$linkId/png/route'
import { Route as appOrgOrgTeamsTeamTeamIdRouteRouteImport } from './routes/(app)/org/$org/teams/team/$teamId/route'
import { Route as appOrgOrgSettingsUserManagementUsersRouteRouteImport } from './routes/(app)/org/$org/settings/user-management/users/route'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/route'
import { Route as appOrgOrgTeamsTeamTeamIdIndexRouteImport } from './routes/(app)/org/$org/teams/team/$teamId/index'
import { Route as appOrgOrgSettingsUserManagementUsersIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/index'
import { Route as appOrgOrgSettingsUserManagementInvitesIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/invites/index'
import { Route as appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/holiday-scheme/index'
import { Route as appOrgOrgSettingsBoxesBoxIdIndexRouteImport } from './routes/(app)/org/$org/settings/boxes/$boxId/index'
import { Route as appOrgOrgRoadmapsRoadmapIdViewIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/index'
import { Route as appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/create/index'
import { Route as appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/product-areas/$productAreaId/index'
import { Route as appOrgOrgIdeaManagementPortalsCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/create/index'
import { Route as appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/$portalId/index'
import { Route as appOrgOrgIdeaManagementInboxFeedbackIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/inbox/$feedbackId/index'
import { Route as appOrgOrgIdeaManagementIdeasViewIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/view/index'
import { Route as appOrgOrgIdeaManagementIdeasCreateIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/create/index'
import { Route as appOrgOrgIdeaManagementIdeasAllIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/all/index'
import { Route as appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/route'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/route'
import { Route as appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport } from './routes/(app)/org/$org/settings/user-management/users/$userId/index'
import { Route as appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport } from './routes/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/index'
import { Route as appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/index'
import { Route as appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/portals/$portalId/$formId/index'
import { Route as appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport } from './routes/(app)/org/$org/idea-management/ideas/view/$viewId/index'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/index'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/route'
import { Route as appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/timeline/index'
import { Route as appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/index'
import { Route as appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRouteImport } from './routes/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane/index'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/index'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/route'
import { Route as appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRouteImport } from './routes/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/index'

const appRouteRoute = appRouteRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRouteImport,
} as any)
const appIndexRoute = appIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedTermsRoute = unauthenticatedTermsRouteImport.update({
  id: '/(unauthenticated)/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedSignupRoute = unauthenticatedSignupRouteImport.update({
  id: '/(unauthenticated)/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const unauthenticatedOrganizationSelectorIndexRoute =
  unauthenticatedOrganizationSelectorIndexRouteImport.update({
    id: '/(unauthenticated)/organization-selector/',
    path: '/organization-selector/',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityIndexRoute =
  unauthenticatedLinkIdentityIndexRouteImport.update({
    id: '/(unauthenticated)/link-identity/',
    path: '/link-identity/',
    getParentRoute: () => rootRouteImport,
  } as any)
const appProfileIndexRoute = appProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgIndexRoute = appOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => appRouteRoute,
} as any)
const appInvitesIndexRoute = appInvitesIndexRouteImport.update({
  id: '/invites/',
  path: '/invites/',
  getParentRoute: () => appRouteRoute,
} as any)
const unauthenticatedOrganizationsStartRoute =
  unauthenticatedOrganizationsStartRouteImport.update({
    id: '/(unauthenticated)/organizations/start',
    path: '/organizations/start',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedLinkIdentityCallbackRoute =
  unauthenticatedLinkIdentityCallbackRouteImport.update({
    id: '/(unauthenticated)/link-identity/callback',
    path: '/link-identity/callback',
    getParentRoute: () => rootRouteImport,
  } as any)
const unauthenticatedOrganizationsInvitesRouteRoute =
  unauthenticatedOrganizationsInvitesRouteRouteImport.update({
    id: '/(unauthenticated)/organizations/invites',
    path: '/organizations/invites',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgRouteRoute = appOrgOrgRouteRouteImport.update({
  id: '/org/$org',
  path: '/org/$org',
  getParentRoute: () => appRouteRoute,
} as any)
const appOrgOrgIndexRoute = appOrgOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const unauthenticatedOrganizationsInvitesAcceptRoute =
  unauthenticatedOrganizationsInvitesAcceptRouteImport.update({
    id: '/accept',
    path: '/accept',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appIntegrationsJiraCallbackRoute =
  appIntegrationsJiraCallbackRouteImport.update({
    id: '/integrations/jira/callback',
    path: '/integrations/jira/callback',
    getParentRoute: () => appRouteRoute,
  } as any)
const unauthenticatedPublishedV1SwimlaneRouteRoute =
  unauthenticatedPublishedV1SwimlaneRouteRouteImport.update({
    id: '/(unauthenticated)/published/v1/swimlane',
    path: '/published/v1/swimlane',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOrgOrgTeamsRouteRoute = appOrgOrgTeamsRouteRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgSettingsRouteRoute = appOrgOrgSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgRoadmapsRouteRoute = appOrgOrgRoadmapsRouteRouteImport.update({
  id: '/roadmaps',
  path: '/roadmaps',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgPortfolioRouteRoute = appOrgOrgPortfolioRouteRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgInsightsRouteRoute = appOrgOrgInsightsRouteRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => appOrgOrgRouteRoute,
} as any)
const appOrgOrgIdeaManagementRouteRoute =
  appOrgOrgIdeaManagementRouteRouteImport.update({
    id: '/idea-management',
    path: '/idea-management',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgContributorsRouteRoute =
  appOrgOrgContributorsRouteRouteImport.update({
    id: '/contributors',
    path: '/contributors',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerRouteRoute =
  appOrgOrgAdaptivePlannerRouteRouteImport.update({
    id: '/adaptive-planner',
    path: '/adaptive-planner',
    getParentRoute: () => appOrgOrgRouteRoute,
  } as any)
const unauthenticatedOrganizationsInvitesErrorIndexRoute =
  unauthenticatedOrganizationsInvitesErrorIndexRouteImport.update({
    id: '/error/',
    path: '/error/',
    getParentRoute: () => unauthenticatedOrganizationsInvitesRouteRoute,
  } as any)
const appOrgOrgTeamsIndexRoute = appOrgOrgTeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgTeamsRouteRoute,
} as any)
const appOrgOrgSettingsIndexRoute = appOrgOrgSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgSettingsRouteRoute,
} as any)
const appOrgOrgRoadmapsIndexRoute = appOrgOrgRoadmapsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgRoadmapsRouteRoute,
} as any)
const appOrgOrgPortfolioIndexRoute = appOrgOrgPortfolioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgPortfolioRouteRoute,
} as any)
const appOrgOrgInsightsIndexRoute = appOrgOrgInsightsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOrgOrgInsightsRouteRoute,
} as any)
const appOrgOrgIdeaManagementIndexRoute =
  appOrgOrgIdeaManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgContributorsIndexRoute =
  appOrgOrgContributorsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgContributorsRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerIndexRoute =
  appOrgOrgAdaptivePlannerIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgAdaptivePlannerRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPriorityFrameworksRoute =
  appOrgOrgIdeaManagementPriorityFrameworksRouteImport.update({
    id: '/priority-frameworks',
    path: '/priority-frameworks',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementOverviewRoute =
  appOrgOrgIdeaManagementOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementCustomFieldsRoute =
  appOrgOrgIdeaManagementCustomFieldsRouteImport.update({
    id: '/custom-fields',
    path: '/custom-fields',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementRouteRoute =
  appOrgOrgSettingsUserManagementRouteRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesRouteRoute =
  appOrgOrgSettingsRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationRouteRoute =
  appOrgOrgSettingsOrganizationRouteRouteImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsRouteRoute =
  appOrgOrgSettingsConnectionsRouteRouteImport.update({
    id: '/connections',
    path: '/connections',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityRouteRoute =
  appOrgOrgSettingsCapacityRouteRouteImport.update({
    id: '/capacity',
    path: '/capacity',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdRouteRoute =
  appOrgOrgRoadmapsRoadmapIdRouteRouteImport.update({
    id: '/$roadmapId',
    path: '/$roadmapId',
    getParentRoute: () => appOrgOrgRoadmapsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsRouteRoute =
  appOrgOrgIdeaManagementPortalsRouteRouteImport.update({
    id: '/portals',
    path: '/portals',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementInboxRouteRoute =
  appOrgOrgIdeaManagementInboxRouteRouteImport.update({
    id: '/inbox',
    path: '/inbox',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute =
  unauthenticatedPublishedV1SwimlaneLinkIdIndexRouteImport.update({
    id: '/$linkId/',
    path: '/$linkId/',
    getParentRoute: () => unauthenticatedPublishedV1SwimlaneRouteRoute,
  } as any)
const appOrgOrgTeamsMembersIndexRoute =
  appOrgOrgTeamsMembersIndexRouteImport.update({
    id: '/members/',
    path: '/members/',
    getParentRoute: () => appOrgOrgTeamsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementIndexRoute =
  appOrgOrgSettingsUserManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsSubscriptionsIndexRoute =
  appOrgOrgSettingsSubscriptionsIndexRouteImport.update({
    id: '/subscriptions/',
    path: '/subscriptions/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsSkillsIndexRoute =
  appOrgOrgSettingsSkillsIndexRouteImport.update({
    id: '/skills/',
    path: '/skills/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsRolesIndexRoute =
  appOrgOrgSettingsRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsRolesRouteRoute,
  } as any)
const appOrgOrgSettingsOrganizationIndexRoute =
  appOrgOrgSettingsOrganizationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsOrganizationRouteRoute,
  } as any)
const appOrgOrgSettingsLocationIndexRoute =
  appOrgOrgSettingsLocationIndexRouteImport.update({
    id: '/location/',
    path: '/location/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsItemTypesIndexRoute =
  appOrgOrgSettingsItemTypesIndexRouteImport.update({
    id: '/item-types/',
    path: '/item-types/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsIntegrationsIndexRoute =
  appOrgOrgSettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsEffortEstimationIndexRoute =
  appOrgOrgSettingsEffortEstimationIndexRouteImport.update({
    id: '/effort-estimation/',
    path: '/effort-estimation/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomItemStatusIndexRoute =
  appOrgOrgSettingsCustomItemStatusIndexRouteImport.update({
    id: '/custom-item-status/',
    path: '/custom-item-status/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsCustomFieldsIndexRoute =
  appOrgOrgSettingsCustomFieldsIndexRouteImport.update({
    id: '/custom-fields/',
    path: '/custom-fields/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgSettingsConnectionsIndexRoute =
  appOrgOrgSettingsConnectionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsConnectionsRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityIndexRoute =
  appOrgOrgSettingsCapacityIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsBoxesIndexRoute =
  appOrgOrgSettingsBoxesIndexRouteImport.update({
    id: '/boxes/',
    path: '/boxes/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdIndexRoute =
  appOrgOrgRoadmapsRoadmapIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdRouteRoute,
  } as any)
const appOrgOrgPortfolioTableIndexRoute =
  appOrgOrgPortfolioTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgPortfolioRouteRoute,
  } as any)
const appOrgOrgInsightsProgressIndexRoute =
  appOrgOrgInsightsProgressIndexRouteImport.update({
    id: '/progress/',
    path: '/progress/',
    getParentRoute: () => appOrgOrgInsightsRouteRoute,
  } as any)
const appOrgOrgInsightsInvestmentBalanceIndexRoute =
  appOrgOrgInsightsInvestmentBalanceIndexRouteImport.update({
    id: '/investment-balance/',
    path: '/investment-balance/',
    getParentRoute: () => appOrgOrgInsightsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasIndexRoute =
  appOrgOrgIdeaManagementProductAreasIndexRouteImport.update({
    id: '/product-areas/',
    path: '/product-areas/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsIndexRoute =
  appOrgOrgIdeaManagementPortalsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementInboxIndexRoute =
  appOrgOrgIdeaManagementInboxIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgIdeaManagementInboxRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasIndexRoute =
  appOrgOrgIdeaManagementIdeasIndexRouteImport.update({
    id: '/ideas/',
    path: '/ideas/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementCustomersIndexRoute =
  appOrgOrgIdeaManagementCustomersIndexRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgContributorsContributorIdIndexRoute =
  appOrgOrgContributorsContributorIdIndexRouteImport.update({
    id: '/$contributorId/',
    path: '/$contributorId/',
    getParentRoute: () => appOrgOrgContributorsRouteRoute,
  } as any)
const unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute =
  unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRouteImport.update({
    id: '/$linkId/png',
    path: '/$linkId/png',
    getParentRoute: () => unauthenticatedPublishedV1SwimlaneRouteRoute,
  } as any)
const appOrgOrgTeamsTeamTeamIdRouteRoute =
  appOrgOrgTeamsTeamTeamIdRouteRouteImport.update({
    id: '/team/$teamId',
    path: '/team/$teamId',
    getParentRoute: () => appOrgOrgTeamsRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersRouteRoute =
  appOrgOrgSettingsUserManagementUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteImport.update({
    id: '/plan/$planId',
    path: '/plan/$planId',
    getParentRoute: () => appOrgOrgAdaptivePlannerRouteRoute,
  } as any)
const appOrgOrgTeamsTeamTeamIdIndexRoute =
  appOrgOrgTeamsTeamTeamIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgTeamsTeamTeamIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersIndexRoute =
  appOrgOrgSettingsUserManagementUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementInvitesIndexRoute =
  appOrgOrgSettingsUserManagementInvitesIndexRouteImport.update({
    id: '/invites/',
    path: '/invites/',
    getParentRoute: () => appOrgOrgSettingsUserManagementRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityHolidaySchemeIndexRoute =
  appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport.update({
    id: '/holiday-scheme/',
    path: '/holiday-scheme/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgSettingsBoxesBoxIdIndexRoute =
  appOrgOrgSettingsBoxesBoxIdIndexRouteImport.update({
    id: '/boxes/$boxId/',
    path: '/boxes/$boxId/',
    getParentRoute: () => appOrgOrgSettingsRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewIndexRoute =
  appOrgOrgRoadmapsRoadmapIdViewIndexRouteImport.update({
    id: '/view/',
    path: '/view/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasCreateIndexRoute =
  appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport.update({
    id: '/product-areas/create/',
    path: '/product-areas/create/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute =
  appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport.update({
    id: '/product-areas/$productAreaId/',
    path: '/product-areas/$productAreaId/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsCreateIndexRoute =
  appOrgOrgIdeaManagementPortalsCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsPortalIdIndexRoute =
  appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport.update({
    id: '/$portalId/',
    path: '/$portalId/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute =
  appOrgOrgIdeaManagementInboxFeedbackIdIndexRouteImport.update({
    id: '/$feedbackId/',
    path: '/$feedbackId/',
    getParentRoute: () => appOrgOrgIdeaManagementInboxRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasViewIndexRoute =
  appOrgOrgIdeaManagementIdeasViewIndexRouteImport.update({
    id: '/ideas/view/',
    path: '/ideas/view/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasCreateIndexRoute =
  appOrgOrgIdeaManagementIdeasCreateIndexRouteImport.update({
    id: '/ideas/create/',
    path: '/ideas/create/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasAllIndexRoute =
  appOrgOrgIdeaManagementIdeasAllIndexRouteImport.update({
    id: '/ideas/all/',
    path: '/ideas/all/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute =
  appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteImport.update({
    id: '/view/$viewId',
    path: '/view/$viewId',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteImport.update({
    id: '/backlog',
    path: '/backlog',
    getParentRoute: () => appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute,
  } as any)
const appOrgOrgSettingsUserManagementUsersUserIdIndexRoute =
  appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport.update({
    id: '/$userId/',
    path: '/$userId/',
    getParentRoute: () => appOrgOrgSettingsUserManagementUsersRouteRoute,
  } as any)
const appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute =
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport.update({
    id: '/holiday-scheme/$holidaySchemeId/',
    path: '/holiday-scheme/$holidaySchemeId/',
    getParentRoute: () => appOrgOrgSettingsCapacityRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute =
  appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute,
  } as any)
const appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute =
  appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport.update({
    id: '/$portalId/$formId/',
    path: '/$portalId/$formId/',
    getParentRoute: () => appOrgOrgIdeaManagementPortalsRouteRoute,
  } as any)
const appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute =
  appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport.update({
    id: '/ideas/view/$viewId/',
    path: '/ideas/view/$viewId/',
    getParentRoute: () => appOrgOrgIdeaManagementRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteImport.update({
    id: '/scenario',
    path: '/scenario',
    getParentRoute: () => appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute =
  appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRouteImport.update({
    id: '/timeline/',
    path: '/timeline/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute =
  appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRouteImport.update({
    id: '/table/',
    path: '/table/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute,
  } as any)
const appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute =
  appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRouteImport.update({
    id: '/swimlane/',
    path: '/swimlane/',
    getParentRoute: () => appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute,
  } as any)
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteImport.update(
    {
      id: '/$scenarioId',
      path: '/$scenarioId',
      getParentRoute: () =>
        appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute,
    } as any,
  )
const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites': typeof appInvitesIndexRoute
  '/org': typeof appOrgIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/link-identity': typeof unauthenticatedLinkIdentityIndexRoute
  '/organization-selector': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/org/$org/adaptive-planner': typeof appOrgOrgAdaptivePlannerRouteRouteWithChildren
  '/org/$org/contributors': typeof appOrgOrgContributorsRouteRouteWithChildren
  '/org/$org/idea-management': typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  '/org/$org/insights': typeof appOrgOrgInsightsRouteRouteWithChildren
  '/org/$org/portfolio': typeof appOrgOrgPortfolioRouteRouteWithChildren
  '/org/$org/roadmaps': typeof appOrgOrgRoadmapsRouteRouteWithChildren
  '/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/org/$org/teams': typeof appOrgOrgTeamsRouteRouteWithChildren
  '/published/v1/swimlane': typeof unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org/': typeof appOrgOrgIndexRoute
  '/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  '/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  '/org/$org/roadmaps/$roadmapId': typeof appOrgOrgRoadmapsRoadmapIdRouteRouteWithChildren
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/org/$org/adaptive-planner/': typeof appOrgOrgAdaptivePlannerIndexRoute
  '/org/$org/contributors/': typeof appOrgOrgContributorsIndexRoute
  '/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/insights/': typeof appOrgOrgInsightsIndexRoute
  '/org/$org/portfolio/': typeof appOrgOrgPortfolioIndexRoute
  '/org/$org/roadmaps/': typeof appOrgOrgRoadmapsIndexRoute
  '/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/teams/': typeof appOrgOrgTeamsIndexRoute
  '/organizations/invites/error': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/adaptive-planner/plan/$planId': typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/org/$org/teams/team/$teamId': typeof appOrgOrgTeamsTeamTeamIdRouteRouteWithChildren
  '/published/v1/swimlane/$linkId/png': typeof unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute
  '/org/$org/contributors/$contributorId': typeof appOrgOrgContributorsContributorIdIndexRoute
  '/org/$org/idea-management/customers': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/org/$org/idea-management/ideas': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/org/$org/idea-management/inbox/': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/org/$org/idea-management/portals/': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/org/$org/idea-management/product-areas': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/org/$org/insights/investment-balance': typeof appOrgOrgInsightsInvestmentBalanceIndexRoute
  '/org/$org/insights/progress': typeof appOrgOrgInsightsProgressIndexRoute
  '/org/$org/portfolio/table': typeof appOrgOrgPortfolioTableIndexRoute
  '/org/$org/roadmaps/$roadmapId/': typeof appOrgOrgRoadmapsRoadmapIdIndexRoute
  '/org/$org/settings/boxes': typeof appOrgOrgSettingsBoxesIndexRoute
  '/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/custom-fields': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/effort-estimation': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/integrations': typeof appOrgOrgSettingsIntegrationsIndexRoute
  '/org/$org/settings/item-types': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/teams/members': typeof appOrgOrgTeamsMembersIndexRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteWithChildren
  '/org/$org/roadmaps/$roadmapId/view/$viewId': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteWithChildren
  '/org/$org/idea-management/ideas/all': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/org/$org/idea-management/ideas/create': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/org/$org/idea-management/ideas/view': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/org/$org/idea-management/inbox/$feedbackId': typeof appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute
  '/org/$org/idea-management/portals/$portalId': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/org/$org/idea-management/portals/create': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/org/$org/idea-management/product-areas/$productAreaId': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/org/$org/idea-management/product-areas/create': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/org/$org/roadmaps/$roadmapId/view': typeof appOrgOrgRoadmapsRoadmapIdViewIndexRoute
  '/org/$org/settings/boxes/$boxId': typeof appOrgOrgSettingsBoxesBoxIdIndexRoute
  '/org/$org/settings/capacity/holiday-scheme': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/org/$org/settings/user-management/invites': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/teams/team/$teamId/': typeof appOrgOrgTeamsTeamTeamIdIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteWithChildren
  '/org/$org/adaptive-planner/plan/$planId/backlog/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute
  '/org/$org/idea-management/ideas/view/$viewId': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/org/$org/idea-management/portals/$portalId/$formId': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/user-management/users/$userId': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteWithChildren
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/table': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/timeline': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute
}
export interface FileRoutesByTo {
  '/signup': typeof unauthenticatedSignupRoute
  '/terms': typeof unauthenticatedTermsRoute
  '/': typeof appIndexRoute
  '/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/invites': typeof appInvitesIndexRoute
  '/org': typeof appOrgIndexRoute
  '/profile': typeof appProfileIndexRoute
  '/link-identity': typeof unauthenticatedLinkIdentityIndexRoute
  '/organization-selector': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/published/v1/swimlane': typeof unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren
  '/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/org/$org': typeof appOrgOrgIndexRoute
  '/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/org/$org/adaptive-planner': typeof appOrgOrgAdaptivePlannerIndexRoute
  '/org/$org/contributors': typeof appOrgOrgContributorsIndexRoute
  '/org/$org/idea-management': typeof appOrgOrgIdeaManagementIndexRoute
  '/org/$org/insights': typeof appOrgOrgInsightsIndexRoute
  '/org/$org/portfolio': typeof appOrgOrgPortfolioIndexRoute
  '/org/$org/roadmaps': typeof appOrgOrgRoadmapsIndexRoute
  '/org/$org/settings': typeof appOrgOrgSettingsIndexRoute
  '/org/$org/teams': typeof appOrgOrgTeamsIndexRoute
  '/organizations/invites/error': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/org/$org/adaptive-planner/plan/$planId': typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren
  '/published/v1/swimlane/$linkId/png': typeof unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute
  '/org/$org/contributors/$contributorId': typeof appOrgOrgContributorsContributorIdIndexRoute
  '/org/$org/idea-management/customers': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/org/$org/idea-management/ideas': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/org/$org/idea-management/product-areas': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/org/$org/insights/investment-balance': typeof appOrgOrgInsightsInvestmentBalanceIndexRoute
  '/org/$org/insights/progress': typeof appOrgOrgInsightsProgressIndexRoute
  '/org/$org/portfolio/table': typeof appOrgOrgPortfolioTableIndexRoute
  '/org/$org/roadmaps/$roadmapId': typeof appOrgOrgRoadmapsRoadmapIdIndexRoute
  '/org/$org/settings/boxes': typeof appOrgOrgSettingsBoxesIndexRoute
  '/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityIndexRoute
  '/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/org/$org/settings/custom-fields': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/org/$org/settings/custom-item-status': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/org/$org/settings/effort-estimation': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/org/$org/settings/integrations': typeof appOrgOrgSettingsIntegrationsIndexRoute
  '/org/$org/settings/item-types': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/org/$org/settings/location': typeof appOrgOrgSettingsLocationIndexRoute
  '/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/org/$org/settings/roles': typeof appOrgOrgSettingsRolesIndexRoute
  '/org/$org/settings/skills': typeof appOrgOrgSettingsSkillsIndexRoute
  '/org/$org/settings/subscriptions': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/org/$org/teams/members': typeof appOrgOrgTeamsMembersIndexRoute
  '/published/v1/swimlane/$linkId': typeof unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute
  '/org/$org/idea-management/ideas/all': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/org/$org/idea-management/ideas/create': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/org/$org/idea-management/ideas/view': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/org/$org/idea-management/inbox/$feedbackId': typeof appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute
  '/org/$org/idea-management/portals/$portalId': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/org/$org/idea-management/portals/create': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/org/$org/idea-management/product-areas/$productAreaId': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/org/$org/idea-management/product-areas/create': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/org/$org/roadmaps/$roadmapId/view': typeof appOrgOrgRoadmapsRoadmapIdViewIndexRoute
  '/org/$org/settings/boxes/$boxId': typeof appOrgOrgSettingsBoxesBoxIdIndexRoute
  '/org/$org/settings/capacity/holiday-scheme': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/org/$org/settings/user-management/invites': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/org/$org/teams/team/$teamId': typeof appOrgOrgTeamsTeamTeamIdIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute
  '/org/$org/idea-management/ideas/view/$viewId': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/org/$org/idea-management/portals/$portalId/$formId': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute
  '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/org/$org/settings/user-management/users/$userId': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/table': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute
  '/org/$org/roadmaps/$roadmapId/view/$viewId/timeline': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute
  '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(app)': typeof appRouteRouteWithChildren
  '/(unauthenticated)/signup': typeof unauthenticatedSignupRoute
  '/(unauthenticated)/terms': typeof unauthenticatedTermsRoute
  '/(app)/': typeof appIndexRoute
  '/(app)/org/$org': typeof appOrgOrgRouteRouteWithChildren
  '/(unauthenticated)/organizations/invites': typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  '/(unauthenticated)/link-identity/callback': typeof unauthenticatedLinkIdentityCallbackRoute
  '/(unauthenticated)/organizations/start': typeof unauthenticatedOrganizationsStartRoute
  '/(app)/invites/': typeof appInvitesIndexRoute
  '/(app)/org/': typeof appOrgIndexRoute
  '/(app)/profile/': typeof appProfileIndexRoute
  '/(unauthenticated)/link-identity/': typeof unauthenticatedLinkIdentityIndexRoute
  '/(unauthenticated)/organization-selector/': typeof unauthenticatedOrganizationSelectorIndexRoute
  '/(app)/org/$org/adaptive-planner': typeof appOrgOrgAdaptivePlannerRouteRouteWithChildren
  '/(app)/org/$org/contributors': typeof appOrgOrgContributorsRouteRouteWithChildren
  '/(app)/org/$org/idea-management': typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  '/(app)/org/$org/insights': typeof appOrgOrgInsightsRouteRouteWithChildren
  '/(app)/org/$org/portfolio': typeof appOrgOrgPortfolioRouteRouteWithChildren
  '/(app)/org/$org/roadmaps': typeof appOrgOrgRoadmapsRouteRouteWithChildren
  '/(app)/org/$org/settings': typeof appOrgOrgSettingsRouteRouteWithChildren
  '/(app)/org/$org/teams': typeof appOrgOrgTeamsRouteRouteWithChildren
  '/(unauthenticated)/published/v1/swimlane': typeof unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren
  '/(app)/integrations/jira/callback': typeof appIntegrationsJiraCallbackRoute
  '/(unauthenticated)/organizations/invites/accept': typeof unauthenticatedOrganizationsInvitesAcceptRoute
  '/(app)/org/$org/': typeof appOrgOrgIndexRoute
  '/(app)/org/$org/idea-management/inbox': typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  '/(app)/org/$org/idea-management/portals': typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  '/(app)/org/$org/roadmaps/$roadmapId': typeof appOrgOrgRoadmapsRoadmapIdRouteRouteWithChildren
  '/(app)/org/$org/settings/capacity': typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  '/(app)/org/$org/settings/connections': typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  '/(app)/org/$org/settings/organization': typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  '/(app)/org/$org/settings/roles': typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management': typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  '/(app)/org/$org/idea-management/custom-fields': typeof appOrgOrgIdeaManagementCustomFieldsRoute
  '/(app)/org/$org/idea-management/overview': typeof appOrgOrgIdeaManagementOverviewRoute
  '/(app)/org/$org/idea-management/priority-frameworks': typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  '/(app)/org/$org/adaptive-planner/': typeof appOrgOrgAdaptivePlannerIndexRoute
  '/(app)/org/$org/contributors/': typeof appOrgOrgContributorsIndexRoute
  '/(app)/org/$org/idea-management/': typeof appOrgOrgIdeaManagementIndexRoute
  '/(app)/org/$org/insights/': typeof appOrgOrgInsightsIndexRoute
  '/(app)/org/$org/portfolio/': typeof appOrgOrgPortfolioIndexRoute
  '/(app)/org/$org/roadmaps/': typeof appOrgOrgRoadmapsIndexRoute
  '/(app)/org/$org/settings/': typeof appOrgOrgSettingsIndexRoute
  '/(app)/org/$org/teams/': typeof appOrgOrgTeamsIndexRoute
  '/(unauthenticated)/organizations/invites/error/': typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
  '/(app)/org/$org/adaptive-planner/plan/$planId': typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren
  '/(app)/org/$org/settings/user-management/users': typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  '/(app)/org/$org/teams/team/$teamId': typeof appOrgOrgTeamsTeamTeamIdRouteRouteWithChildren
  '/(unauthenticated)/published/v1/swimlane/$linkId/png': typeof unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute
  '/(app)/org/$org/contributors/$contributorId/': typeof appOrgOrgContributorsContributorIdIndexRoute
  '/(app)/org/$org/idea-management/customers/': typeof appOrgOrgIdeaManagementCustomersIndexRoute
  '/(app)/org/$org/idea-management/ideas/': typeof appOrgOrgIdeaManagementIdeasIndexRoute
  '/(app)/org/$org/idea-management/inbox/': typeof appOrgOrgIdeaManagementInboxIndexRoute
  '/(app)/org/$org/idea-management/portals/': typeof appOrgOrgIdeaManagementPortalsIndexRoute
  '/(app)/org/$org/idea-management/product-areas/': typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  '/(app)/org/$org/insights/investment-balance/': typeof appOrgOrgInsightsInvestmentBalanceIndexRoute
  '/(app)/org/$org/insights/progress/': typeof appOrgOrgInsightsProgressIndexRoute
  '/(app)/org/$org/portfolio/table/': typeof appOrgOrgPortfolioTableIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/': typeof appOrgOrgRoadmapsRoadmapIdIndexRoute
  '/(app)/org/$org/settings/boxes/': typeof appOrgOrgSettingsBoxesIndexRoute
  '/(app)/org/$org/settings/capacity/': typeof appOrgOrgSettingsCapacityIndexRoute
  '/(app)/org/$org/settings/connections/': typeof appOrgOrgSettingsConnectionsIndexRoute
  '/(app)/org/$org/settings/custom-fields/': typeof appOrgOrgSettingsCustomFieldsIndexRoute
  '/(app)/org/$org/settings/custom-item-status/': typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  '/(app)/org/$org/settings/effort-estimation/': typeof appOrgOrgSettingsEffortEstimationIndexRoute
  '/(app)/org/$org/settings/integrations/': typeof appOrgOrgSettingsIntegrationsIndexRoute
  '/(app)/org/$org/settings/item-types/': typeof appOrgOrgSettingsItemTypesIndexRoute
  '/(app)/org/$org/settings/location/': typeof appOrgOrgSettingsLocationIndexRoute
  '/(app)/org/$org/settings/organization/': typeof appOrgOrgSettingsOrganizationIndexRoute
  '/(app)/org/$org/settings/roles/': typeof appOrgOrgSettingsRolesIndexRoute
  '/(app)/org/$org/settings/skills/': typeof appOrgOrgSettingsSkillsIndexRoute
  '/(app)/org/$org/settings/subscriptions/': typeof appOrgOrgSettingsSubscriptionsIndexRoute
  '/(app)/org/$org/settings/user-management/': typeof appOrgOrgSettingsUserManagementIndexRoute
  '/(app)/org/$org/teams/members/': typeof appOrgOrgTeamsMembersIndexRoute
  '/(unauthenticated)/published/v1/swimlane/$linkId/': typeof unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteWithChildren
  '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteWithChildren
  '/(app)/org/$org/idea-management/ideas/all/': typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  '/(app)/org/$org/idea-management/ideas/create/': typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  '/(app)/org/$org/idea-management/ideas/view/': typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  '/(app)/org/$org/idea-management/inbox/$feedbackId/': typeof appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute
  '/(app)/org/$org/idea-management/portals/$portalId/': typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  '/(app)/org/$org/idea-management/portals/create/': typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  '/(app)/org/$org/idea-management/product-areas/$productAreaId/': typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  '/(app)/org/$org/idea-management/product-areas/create/': typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/view/': typeof appOrgOrgRoadmapsRoadmapIdViewIndexRoute
  '/(app)/org/$org/settings/boxes/$boxId/': typeof appOrgOrgSettingsBoxesBoxIdIndexRoute
  '/(app)/org/$org/settings/capacity/holiday-scheme/': typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  '/(app)/org/$org/settings/user-management/invites/': typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
  '/(app)/org/$org/settings/user-management/users/': typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  '/(app)/org/$org/teams/team/$teamId/': typeof appOrgOrgTeamsTeamTeamIdIndexRoute
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteWithChildren
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute
  '/(app)/org/$org/idea-management/ideas/view/$viewId/': typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
  '/(app)/org/$org/idea-management/portals/$portalId/$formId/': typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute
  '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
  '/(app)/org/$org/settings/user-management/users/$userId/': typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteWithChildren
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane/': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute
  '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/timeline/': typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/': typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/signup'
    | '/terms'
    | '/'
    | '/org/$org'
    | '/organizations/invites'
    | '/link-identity/callback'
    | '/organizations/start'
    | '/invites'
    | '/org'
    | '/profile'
    | '/link-identity'
    | '/organization-selector'
    | '/org/$org/adaptive-planner'
    | '/org/$org/contributors'
    | '/org/$org/idea-management'
    | '/org/$org/insights'
    | '/org/$org/portfolio'
    | '/org/$org/roadmaps'
    | '/org/$org/settings'
    | '/org/$org/teams'
    | '/published/v1/swimlane'
    | '/integrations/jira/callback'
    | '/organizations/invites/accept'
    | '/org/$org/'
    | '/org/$org/idea-management/inbox'
    | '/org/$org/idea-management/portals'
    | '/org/$org/roadmaps/$roadmapId'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/user-management'
    | '/org/$org/idea-management/custom-fields'
    | '/org/$org/idea-management/overview'
    | '/org/$org/idea-management/priority-frameworks'
    | '/org/$org/adaptive-planner/'
    | '/org/$org/contributors/'
    | '/org/$org/idea-management/'
    | '/org/$org/insights/'
    | '/org/$org/portfolio/'
    | '/org/$org/roadmaps/'
    | '/org/$org/settings/'
    | '/org/$org/teams/'
    | '/organizations/invites/error'
    | '/org/$org/adaptive-planner/plan/$planId'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/teams/team/$teamId'
    | '/published/v1/swimlane/$linkId/png'
    | '/org/$org/contributors/$contributorId'
    | '/org/$org/idea-management/customers'
    | '/org/$org/idea-management/ideas'
    | '/org/$org/idea-management/inbox/'
    | '/org/$org/idea-management/portals/'
    | '/org/$org/idea-management/product-areas'
    | '/org/$org/insights/investment-balance'
    | '/org/$org/insights/progress'
    | '/org/$org/portfolio/table'
    | '/org/$org/roadmaps/$roadmapId/'
    | '/org/$org/settings/boxes'
    | '/org/$org/settings/capacity/'
    | '/org/$org/settings/connections/'
    | '/org/$org/settings/custom-fields'
    | '/org/$org/settings/custom-item-status'
    | '/org/$org/settings/effort-estimation'
    | '/org/$org/settings/integrations'
    | '/org/$org/settings/item-types'
    | '/org/$org/settings/location'
    | '/org/$org/settings/organization/'
    | '/org/$org/settings/roles/'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/user-management/'
    | '/org/$org/teams/members'
    | '/published/v1/swimlane/$linkId'
    | '/org/$org/adaptive-planner/plan/$planId/backlog'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId'
    | '/org/$org/idea-management/ideas/all'
    | '/org/$org/idea-management/ideas/create'
    | '/org/$org/idea-management/ideas/view'
    | '/org/$org/idea-management/inbox/$feedbackId'
    | '/org/$org/idea-management/portals/$portalId'
    | '/org/$org/idea-management/portals/create'
    | '/org/$org/idea-management/product-areas/$productAreaId'
    | '/org/$org/idea-management/product-areas/create'
    | '/org/$org/roadmaps/$roadmapId/view'
    | '/org/$org/settings/boxes/$boxId'
    | '/org/$org/settings/capacity/holiday-scheme'
    | '/org/$org/settings/user-management/invites'
    | '/org/$org/settings/user-management/users/'
    | '/org/$org/teams/team/$teamId/'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/'
    | '/org/$org/idea-management/ideas/view/$viewId'
    | '/org/$org/idea-management/portals/$portalId/$formId'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId'
    | '/org/$org/settings/user-management/users/$userId'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/table'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/timeline'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/signup'
    | '/terms'
    | '/'
    | '/organizations/invites'
    | '/link-identity/callback'
    | '/organizations/start'
    | '/invites'
    | '/org'
    | '/profile'
    | '/link-identity'
    | '/organization-selector'
    | '/published/v1/swimlane'
    | '/integrations/jira/callback'
    | '/organizations/invites/accept'
    | '/org/$org'
    | '/org/$org/idea-management/custom-fields'
    | '/org/$org/idea-management/overview'
    | '/org/$org/idea-management/priority-frameworks'
    | '/org/$org/adaptive-planner'
    | '/org/$org/contributors'
    | '/org/$org/idea-management'
    | '/org/$org/insights'
    | '/org/$org/portfolio'
    | '/org/$org/roadmaps'
    | '/org/$org/settings'
    | '/org/$org/teams'
    | '/organizations/invites/error'
    | '/org/$org/adaptive-planner/plan/$planId'
    | '/published/v1/swimlane/$linkId/png'
    | '/org/$org/contributors/$contributorId'
    | '/org/$org/idea-management/customers'
    | '/org/$org/idea-management/ideas'
    | '/org/$org/idea-management/inbox'
    | '/org/$org/idea-management/portals'
    | '/org/$org/idea-management/product-areas'
    | '/org/$org/insights/investment-balance'
    | '/org/$org/insights/progress'
    | '/org/$org/portfolio/table'
    | '/org/$org/roadmaps/$roadmapId'
    | '/org/$org/settings/boxes'
    | '/org/$org/settings/capacity'
    | '/org/$org/settings/connections'
    | '/org/$org/settings/custom-fields'
    | '/org/$org/settings/custom-item-status'
    | '/org/$org/settings/effort-estimation'
    | '/org/$org/settings/integrations'
    | '/org/$org/settings/item-types'
    | '/org/$org/settings/location'
    | '/org/$org/settings/organization'
    | '/org/$org/settings/roles'
    | '/org/$org/settings/skills'
    | '/org/$org/settings/subscriptions'
    | '/org/$org/settings/user-management'
    | '/org/$org/teams/members'
    | '/published/v1/swimlane/$linkId'
    | '/org/$org/idea-management/ideas/all'
    | '/org/$org/idea-management/ideas/create'
    | '/org/$org/idea-management/ideas/view'
    | '/org/$org/idea-management/inbox/$feedbackId'
    | '/org/$org/idea-management/portals/$portalId'
    | '/org/$org/idea-management/portals/create'
    | '/org/$org/idea-management/product-areas/$productAreaId'
    | '/org/$org/idea-management/product-areas/create'
    | '/org/$org/roadmaps/$roadmapId/view'
    | '/org/$org/settings/boxes/$boxId'
    | '/org/$org/settings/capacity/holiday-scheme'
    | '/org/$org/settings/user-management/invites'
    | '/org/$org/settings/user-management/users'
    | '/org/$org/teams/team/$teamId'
    | '/org/$org/adaptive-planner/plan/$planId/backlog'
    | '/org/$org/idea-management/ideas/view/$viewId'
    | '/org/$org/idea-management/portals/$portalId/$formId'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId'
    | '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId'
    | '/org/$org/settings/user-management/users/$userId'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/table'
    | '/org/$org/roadmaps/$roadmapId/view/$viewId/timeline'
    | '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId'
  id:
    | '__root__'
    | '/(app)'
    | '/(unauthenticated)/signup'
    | '/(unauthenticated)/terms'
    | '/(app)/'
    | '/(app)/org/$org'
    | '/(unauthenticated)/organizations/invites'
    | '/(unauthenticated)/link-identity/callback'
    | '/(unauthenticated)/organizations/start'
    | '/(app)/invites/'
    | '/(app)/org/'
    | '/(app)/profile/'
    | '/(unauthenticated)/link-identity/'
    | '/(unauthenticated)/organization-selector/'
    | '/(app)/org/$org/adaptive-planner'
    | '/(app)/org/$org/contributors'
    | '/(app)/org/$org/idea-management'
    | '/(app)/org/$org/insights'
    | '/(app)/org/$org/portfolio'
    | '/(app)/org/$org/roadmaps'
    | '/(app)/org/$org/settings'
    | '/(app)/org/$org/teams'
    | '/(unauthenticated)/published/v1/swimlane'
    | '/(app)/integrations/jira/callback'
    | '/(unauthenticated)/organizations/invites/accept'
    | '/(app)/org/$org/'
    | '/(app)/org/$org/idea-management/inbox'
    | '/(app)/org/$org/idea-management/portals'
    | '/(app)/org/$org/roadmaps/$roadmapId'
    | '/(app)/org/$org/settings/capacity'
    | '/(app)/org/$org/settings/connections'
    | '/(app)/org/$org/settings/organization'
    | '/(app)/org/$org/settings/roles'
    | '/(app)/org/$org/settings/user-management'
    | '/(app)/org/$org/idea-management/custom-fields'
    | '/(app)/org/$org/idea-management/overview'
    | '/(app)/org/$org/idea-management/priority-frameworks'
    | '/(app)/org/$org/adaptive-planner/'
    | '/(app)/org/$org/contributors/'
    | '/(app)/org/$org/idea-management/'
    | '/(app)/org/$org/insights/'
    | '/(app)/org/$org/portfolio/'
    | '/(app)/org/$org/roadmaps/'
    | '/(app)/org/$org/settings/'
    | '/(app)/org/$org/teams/'
    | '/(unauthenticated)/organizations/invites/error/'
    | '/(app)/org/$org/adaptive-planner/plan/$planId'
    | '/(app)/org/$org/settings/user-management/users'
    | '/(app)/org/$org/teams/team/$teamId'
    | '/(unauthenticated)/published/v1/swimlane/$linkId/png'
    | '/(app)/org/$org/contributors/$contributorId/'
    | '/(app)/org/$org/idea-management/customers/'
    | '/(app)/org/$org/idea-management/ideas/'
    | '/(app)/org/$org/idea-management/inbox/'
    | '/(app)/org/$org/idea-management/portals/'
    | '/(app)/org/$org/idea-management/product-areas/'
    | '/(app)/org/$org/insights/investment-balance/'
    | '/(app)/org/$org/insights/progress/'
    | '/(app)/org/$org/portfolio/table/'
    | '/(app)/org/$org/roadmaps/$roadmapId/'
    | '/(app)/org/$org/settings/boxes/'
    | '/(app)/org/$org/settings/capacity/'
    | '/(app)/org/$org/settings/connections/'
    | '/(app)/org/$org/settings/custom-fields/'
    | '/(app)/org/$org/settings/custom-item-status/'
    | '/(app)/org/$org/settings/effort-estimation/'
    | '/(app)/org/$org/settings/integrations/'
    | '/(app)/org/$org/settings/item-types/'
    | '/(app)/org/$org/settings/location/'
    | '/(app)/org/$org/settings/organization/'
    | '/(app)/org/$org/settings/roles/'
    | '/(app)/org/$org/settings/skills/'
    | '/(app)/org/$org/settings/subscriptions/'
    | '/(app)/org/$org/settings/user-management/'
    | '/(app)/org/$org/teams/members/'
    | '/(unauthenticated)/published/v1/swimlane/$linkId/'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId'
    | '/(app)/org/$org/idea-management/ideas/all/'
    | '/(app)/org/$org/idea-management/ideas/create/'
    | '/(app)/org/$org/idea-management/ideas/view/'
    | '/(app)/org/$org/idea-management/inbox/$feedbackId/'
    | '/(app)/org/$org/idea-management/portals/$portalId/'
    | '/(app)/org/$org/idea-management/portals/create/'
    | '/(app)/org/$org/idea-management/product-areas/$productAreaId/'
    | '/(app)/org/$org/idea-management/product-areas/create/'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/'
    | '/(app)/org/$org/settings/boxes/$boxId/'
    | '/(app)/org/$org/settings/capacity/holiday-scheme/'
    | '/(app)/org/$org/settings/user-management/invites/'
    | '/(app)/org/$org/settings/user-management/users/'
    | '/(app)/org/$org/teams/team/$teamId/'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/'
    | '/(app)/org/$org/idea-management/ideas/view/$viewId/'
    | '/(app)/org/$org/idea-management/portals/$portalId/$formId/'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/'
    | '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
    | '/(app)/org/$org/settings/user-management/users/$userId/'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane/'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/'
    | '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/timeline/'
    | '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  appRouteRoute: typeof appRouteRouteWithChildren
  unauthenticatedSignupRoute: typeof unauthenticatedSignupRoute
  unauthenticatedTermsRoute: typeof unauthenticatedTermsRoute
  unauthenticatedOrganizationsInvitesRouteRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteWithChildren
  unauthenticatedLinkIdentityCallbackRoute: typeof unauthenticatedLinkIdentityCallbackRoute
  unauthenticatedOrganizationsStartRoute: typeof unauthenticatedOrganizationsStartRoute
  unauthenticatedLinkIdentityIndexRoute: typeof unauthenticatedLinkIdentityIndexRoute
  unauthenticatedOrganizationSelectorIndexRoute: typeof unauthenticatedOrganizationSelectorIndexRoute
  unauthenticatedPublishedV1SwimlaneRouteRoute: typeof unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof appRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/': {
      id: '/(app)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/terms': {
      id: '/(unauthenticated)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof unauthenticatedTermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/signup': {
      id: '/(unauthenticated)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof unauthenticatedSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organization-selector/': {
      id: '/(unauthenticated)/organization-selector/'
      path: '/organization-selector'
      fullPath: '/organization-selector'
      preLoaderRoute: typeof unauthenticatedOrganizationSelectorIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/': {
      id: '/(unauthenticated)/link-identity/'
      path: '/link-identity'
      fullPath: '/link-identity'
      preLoaderRoute: typeof unauthenticatedLinkIdentityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/profile/': {
      id: '/(app)/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof appProfileIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/': {
      id: '/(app)/org/'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof appOrgIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/invites/': {
      id: '/(app)/invites/'
      path: '/invites'
      fullPath: '/invites'
      preLoaderRoute: typeof appInvitesIndexRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/organizations/start': {
      id: '/(unauthenticated)/organizations/start'
      path: '/organizations/start'
      fullPath: '/organizations/start'
      preLoaderRoute: typeof unauthenticatedOrganizationsStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/link-identity/callback': {
      id: '/(unauthenticated)/link-identity/callback'
      path: '/link-identity/callback'
      fullPath: '/link-identity/callback'
      preLoaderRoute: typeof unauthenticatedLinkIdentityCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(unauthenticated)/organizations/invites': {
      id: '/(unauthenticated)/organizations/invites'
      path: '/organizations/invites'
      fullPath: '/organizations/invites'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org': {
      id: '/(app)/org/$org'
      path: '/org/$org'
      fullPath: '/org/$org'
      preLoaderRoute: typeof appOrgOrgRouteRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(app)/org/$org/': {
      id: '/(app)/org/$org/'
      path: '/'
      fullPath: '/org/$org/'
      preLoaderRoute: typeof appOrgOrgIndexRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/accept': {
      id: '/(unauthenticated)/organizations/invites/accept'
      path: '/accept'
      fullPath: '/organizations/invites/accept'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesAcceptRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/integrations/jira/callback': {
      id: '/(app)/integrations/jira/callback'
      path: '/integrations/jira/callback'
      fullPath: '/integrations/jira/callback'
      preLoaderRoute: typeof appIntegrationsJiraCallbackRouteImport
      parentRoute: typeof appRouteRoute
    }
    '/(unauthenticated)/published/v1/swimlane': {
      id: '/(unauthenticated)/published/v1/swimlane'
      path: '/published/v1/swimlane'
      fullPath: '/published/v1/swimlane'
      preLoaderRoute: typeof unauthenticatedPublishedV1SwimlaneRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/org/$org/teams': {
      id: '/(app)/org/$org/teams'
      path: '/teams'
      fullPath: '/org/$org/teams'
      preLoaderRoute: typeof appOrgOrgTeamsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/settings': {
      id: '/(app)/org/$org/settings'
      path: '/settings'
      fullPath: '/org/$org/settings'
      preLoaderRoute: typeof appOrgOrgSettingsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/roadmaps': {
      id: '/(app)/org/$org/roadmaps'
      path: '/roadmaps'
      fullPath: '/org/$org/roadmaps'
      preLoaderRoute: typeof appOrgOrgRoadmapsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/portfolio': {
      id: '/(app)/org/$org/portfolio'
      path: '/portfolio'
      fullPath: '/org/$org/portfolio'
      preLoaderRoute: typeof appOrgOrgPortfolioRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/insights': {
      id: '/(app)/org/$org/insights'
      path: '/insights'
      fullPath: '/org/$org/insights'
      preLoaderRoute: typeof appOrgOrgInsightsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/idea-management': {
      id: '/(app)/org/$org/idea-management'
      path: '/idea-management'
      fullPath: '/org/$org/idea-management'
      preLoaderRoute: typeof appOrgOrgIdeaManagementRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/contributors': {
      id: '/(app)/org/$org/contributors'
      path: '/contributors'
      fullPath: '/org/$org/contributors'
      preLoaderRoute: typeof appOrgOrgContributorsRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(app)/org/$org/adaptive-planner': {
      id: '/(app)/org/$org/adaptive-planner'
      path: '/adaptive-planner'
      fullPath: '/org/$org/adaptive-planner'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerRouteRouteImport
      parentRoute: typeof appOrgOrgRouteRoute
    }
    '/(unauthenticated)/organizations/invites/error/': {
      id: '/(unauthenticated)/organizations/invites/error/'
      path: '/error'
      fullPath: '/organizations/invites/error'
      preLoaderRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRouteImport
      parentRoute: typeof unauthenticatedOrganizationsInvitesRouteRoute
    }
    '/(app)/org/$org/teams/': {
      id: '/(app)/org/$org/teams/'
      path: '/'
      fullPath: '/org/$org/teams/'
      preLoaderRoute: typeof appOrgOrgTeamsIndexRouteImport
      parentRoute: typeof appOrgOrgTeamsRouteRoute
    }
    '/(app)/org/$org/settings/': {
      id: '/(app)/org/$org/settings/'
      path: '/'
      fullPath: '/org/$org/settings/'
      preLoaderRoute: typeof appOrgOrgSettingsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/roadmaps/': {
      id: '/(app)/org/$org/roadmaps/'
      path: '/'
      fullPath: '/org/$org/roadmaps/'
      preLoaderRoute: typeof appOrgOrgRoadmapsIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRouteRoute
    }
    '/(app)/org/$org/portfolio/': {
      id: '/(app)/org/$org/portfolio/'
      path: '/'
      fullPath: '/org/$org/portfolio/'
      preLoaderRoute: typeof appOrgOrgPortfolioIndexRouteImport
      parentRoute: typeof appOrgOrgPortfolioRouteRoute
    }
    '/(app)/org/$org/insights/': {
      id: '/(app)/org/$org/insights/'
      path: '/'
      fullPath: '/org/$org/insights/'
      preLoaderRoute: typeof appOrgOrgInsightsIndexRouteImport
      parentRoute: typeof appOrgOrgInsightsRouteRoute
    }
    '/(app)/org/$org/idea-management/': {
      id: '/(app)/org/$org/idea-management/'
      path: '/'
      fullPath: '/org/$org/idea-management/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/contributors/': {
      id: '/(app)/org/$org/contributors/'
      path: '/'
      fullPath: '/org/$org/contributors/'
      preLoaderRoute: typeof appOrgOrgContributorsIndexRouteImport
      parentRoute: typeof appOrgOrgContributorsRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/': {
      id: '/(app)/org/$org/adaptive-planner/'
      path: '/'
      fullPath: '/org/$org/adaptive-planner/'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerIndexRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerRouteRoute
    }
    '/(app)/org/$org/idea-management/priority-frameworks': {
      id: '/(app)/org/$org/idea-management/priority-frameworks'
      path: '/priority-frameworks'
      fullPath: '/org/$org/idea-management/priority-frameworks'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPriorityFrameworksRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/overview': {
      id: '/(app)/org/$org/idea-management/overview'
      path: '/overview'
      fullPath: '/org/$org/idea-management/overview'
      preLoaderRoute: typeof appOrgOrgIdeaManagementOverviewRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/custom-fields': {
      id: '/(app)/org/$org/idea-management/custom-fields'
      path: '/custom-fields'
      fullPath: '/org/$org/idea-management/custom-fields'
      preLoaderRoute: typeof appOrgOrgIdeaManagementCustomFieldsRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/settings/user-management': {
      id: '/(app)/org/$org/settings/user-management'
      path: '/user-management'
      fullPath: '/org/$org/settings/user-management'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/roles': {
      id: '/(app)/org/$org/settings/roles'
      path: '/roles'
      fullPath: '/org/$org/settings/roles'
      preLoaderRoute: typeof appOrgOrgSettingsRolesRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/organization': {
      id: '/(app)/org/$org/settings/organization'
      path: '/organization'
      fullPath: '/org/$org/settings/organization'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/connections': {
      id: '/(app)/org/$org/settings/connections'
      path: '/connections'
      fullPath: '/org/$org/settings/connections'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/capacity': {
      id: '/(app)/org/$org/settings/capacity'
      path: '/capacity'
      fullPath: '/org/$org/settings/capacity'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId': {
      id: '/(app)/org/$org/roadmaps/$roadmapId'
      path: '/$roadmapId'
      fullPath: '/org/$org/roadmaps/$roadmapId'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdRouteRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRouteRoute
    }
    '/(app)/org/$org/idea-management/portals': {
      id: '/(app)/org/$org/idea-management/portals'
      path: '/portals'
      fullPath: '/org/$org/idea-management/portals'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsRouteRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/inbox': {
      id: '/(app)/org/$org/idea-management/inbox'
      path: '/inbox'
      fullPath: '/org/$org/idea-management/inbox'
      preLoaderRoute: typeof appOrgOrgIdeaManagementInboxRouteRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(unauthenticated)/published/v1/swimlane/$linkId/': {
      id: '/(unauthenticated)/published/v1/swimlane/$linkId/'
      path: '/$linkId'
      fullPath: '/published/v1/swimlane/$linkId'
      preLoaderRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdIndexRouteImport
      parentRoute: typeof unauthenticatedPublishedV1SwimlaneRouteRoute
    }
    '/(app)/org/$org/teams/members/': {
      id: '/(app)/org/$org/teams/members/'
      path: '/members'
      fullPath: '/org/$org/teams/members'
      preLoaderRoute: typeof appOrgOrgTeamsMembersIndexRouteImport
      parentRoute: typeof appOrgOrgTeamsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/': {
      id: '/(app)/org/$org/settings/user-management/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/subscriptions/': {
      id: '/(app)/org/$org/settings/subscriptions/'
      path: '/subscriptions'
      fullPath: '/org/$org/settings/subscriptions'
      preLoaderRoute: typeof appOrgOrgSettingsSubscriptionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/skills/': {
      id: '/(app)/org/$org/settings/skills/'
      path: '/skills'
      fullPath: '/org/$org/settings/skills'
      preLoaderRoute: typeof appOrgOrgSettingsSkillsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/roles/': {
      id: '/(app)/org/$org/settings/roles/'
      path: '/'
      fullPath: '/org/$org/settings/roles/'
      preLoaderRoute: typeof appOrgOrgSettingsRolesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRolesRouteRoute
    }
    '/(app)/org/$org/settings/organization/': {
      id: '/(app)/org/$org/settings/organization/'
      path: '/'
      fullPath: '/org/$org/settings/organization/'
      preLoaderRoute: typeof appOrgOrgSettingsOrganizationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsOrganizationRouteRoute
    }
    '/(app)/org/$org/settings/location/': {
      id: '/(app)/org/$org/settings/location/'
      path: '/location'
      fullPath: '/org/$org/settings/location'
      preLoaderRoute: typeof appOrgOrgSettingsLocationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/item-types/': {
      id: '/(app)/org/$org/settings/item-types/'
      path: '/item-types'
      fullPath: '/org/$org/settings/item-types'
      preLoaderRoute: typeof appOrgOrgSettingsItemTypesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/integrations/': {
      id: '/(app)/org/$org/settings/integrations/'
      path: '/integrations'
      fullPath: '/org/$org/settings/integrations'
      preLoaderRoute: typeof appOrgOrgSettingsIntegrationsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/effort-estimation/': {
      id: '/(app)/org/$org/settings/effort-estimation/'
      path: '/effort-estimation'
      fullPath: '/org/$org/settings/effort-estimation'
      preLoaderRoute: typeof appOrgOrgSettingsEffortEstimationIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/custom-item-status/': {
      id: '/(app)/org/$org/settings/custom-item-status/'
      path: '/custom-item-status'
      fullPath: '/org/$org/settings/custom-item-status'
      preLoaderRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/custom-fields/': {
      id: '/(app)/org/$org/settings/custom-fields/'
      path: '/custom-fields'
      fullPath: '/org/$org/settings/custom-fields'
      preLoaderRoute: typeof appOrgOrgSettingsCustomFieldsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/settings/connections/': {
      id: '/(app)/org/$org/settings/connections/'
      path: '/'
      fullPath: '/org/$org/settings/connections/'
      preLoaderRoute: typeof appOrgOrgSettingsConnectionsIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsConnectionsRouteRoute
    }
    '/(app)/org/$org/settings/capacity/': {
      id: '/(app)/org/$org/settings/capacity/'
      path: '/'
      fullPath: '/org/$org/settings/capacity/'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/boxes/': {
      id: '/(app)/org/$org/settings/boxes/'
      path: '/boxes'
      fullPath: '/org/$org/settings/boxes'
      preLoaderRoute: typeof appOrgOrgSettingsBoxesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/'
      path: '/'
      fullPath: '/org/$org/roadmaps/$roadmapId/'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdRouteRoute
    }
    '/(app)/org/$org/portfolio/table/': {
      id: '/(app)/org/$org/portfolio/table/'
      path: '/table'
      fullPath: '/org/$org/portfolio/table'
      preLoaderRoute: typeof appOrgOrgPortfolioTableIndexRouteImport
      parentRoute: typeof appOrgOrgPortfolioRouteRoute
    }
    '/(app)/org/$org/insights/progress/': {
      id: '/(app)/org/$org/insights/progress/'
      path: '/progress'
      fullPath: '/org/$org/insights/progress'
      preLoaderRoute: typeof appOrgOrgInsightsProgressIndexRouteImport
      parentRoute: typeof appOrgOrgInsightsRouteRoute
    }
    '/(app)/org/$org/insights/investment-balance/': {
      id: '/(app)/org/$org/insights/investment-balance/'
      path: '/investment-balance'
      fullPath: '/org/$org/insights/investment-balance'
      preLoaderRoute: typeof appOrgOrgInsightsInvestmentBalanceIndexRouteImport
      parentRoute: typeof appOrgOrgInsightsRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/': {
      id: '/(app)/org/$org/idea-management/product-areas/'
      path: '/product-areas'
      fullPath: '/org/$org/idea-management/product-areas'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/': {
      id: '/(app)/org/$org/idea-management/portals/'
      path: '/'
      fullPath: '/org/$org/idea-management/portals/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/inbox/': {
      id: '/(app)/org/$org/idea-management/inbox/'
      path: '/'
      fullPath: '/org/$org/idea-management/inbox/'
      preLoaderRoute: typeof appOrgOrgIdeaManagementInboxIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementInboxRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/': {
      id: '/(app)/org/$org/idea-management/ideas/'
      path: '/ideas'
      fullPath: '/org/$org/idea-management/ideas'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/customers/': {
      id: '/(app)/org/$org/idea-management/customers/'
      path: '/customers'
      fullPath: '/org/$org/idea-management/customers'
      preLoaderRoute: typeof appOrgOrgIdeaManagementCustomersIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/contributors/$contributorId/': {
      id: '/(app)/org/$org/contributors/$contributorId/'
      path: '/$contributorId'
      fullPath: '/org/$org/contributors/$contributorId'
      preLoaderRoute: typeof appOrgOrgContributorsContributorIdIndexRouteImport
      parentRoute: typeof appOrgOrgContributorsRouteRoute
    }
    '/(unauthenticated)/published/v1/swimlane/$linkId/png': {
      id: '/(unauthenticated)/published/v1/swimlane/$linkId/png'
      path: '/$linkId/png'
      fullPath: '/published/v1/swimlane/$linkId/png'
      preLoaderRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRouteImport
      parentRoute: typeof unauthenticatedPublishedV1SwimlaneRouteRoute
    }
    '/(app)/org/$org/teams/team/$teamId': {
      id: '/(app)/org/$org/teams/team/$teamId'
      path: '/team/$teamId'
      fullPath: '/org/$org/teams/team/$teamId'
      preLoaderRoute: typeof appOrgOrgTeamsTeamTeamIdRouteRouteImport
      parentRoute: typeof appOrgOrgTeamsRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users': {
      id: '/(app)/org/$org/settings/user-management/users'
      path: '/users'
      fullPath: '/org/$org/settings/user-management/users'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId'
      path: '/plan/$planId'
      fullPath: '/org/$org/adaptive-planner/plan/$planId'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerRouteRoute
    }
    '/(app)/org/$org/teams/team/$teamId/': {
      id: '/(app)/org/$org/teams/team/$teamId/'
      path: '/'
      fullPath: '/org/$org/teams/team/$teamId/'
      preLoaderRoute: typeof appOrgOrgTeamsTeamTeamIdIndexRouteImport
      parentRoute: typeof appOrgOrgTeamsTeamTeamIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/': {
      id: '/(app)/org/$org/settings/user-management/users/'
      path: '/'
      fullPath: '/org/$org/settings/user-management/users/'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/user-management/invites/': {
      id: '/(app)/org/$org/settings/user-management/invites/'
      path: '/invites'
      fullPath: '/org/$org/settings/user-management/invites'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementRouteRoute
    }
    '/(app)/org/$org/settings/capacity/holiday-scheme/': {
      id: '/(app)/org/$org/settings/capacity/holiday-scheme/'
      path: '/holiday-scheme'
      fullPath: '/org/$org/settings/capacity/holiday-scheme'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/settings/boxes/$boxId/': {
      id: '/(app)/org/$org/settings/boxes/$boxId/'
      path: '/boxes/$boxId'
      fullPath: '/org/$org/settings/boxes/$boxId'
      preLoaderRoute: typeof appOrgOrgSettingsBoxesBoxIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/'
      path: '/view'
      fullPath: '/org/$org/roadmaps/$roadmapId/view'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/create/': {
      id: '/(app)/org/$org/idea-management/product-areas/create/'
      path: '/product-areas/create'
      fullPath: '/org/$org/idea-management/product-areas/create'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/product-areas/$productAreaId/': {
      id: '/(app)/org/$org/idea-management/product-areas/$productAreaId/'
      path: '/product-areas/$productAreaId'
      fullPath: '/org/$org/idea-management/product-areas/$productAreaId'
      preLoaderRoute: typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/create/': {
      id: '/(app)/org/$org/idea-management/portals/create/'
      path: '/create'
      fullPath: '/org/$org/idea-management/portals/create'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/$portalId/': {
      id: '/(app)/org/$org/idea-management/portals/$portalId/'
      path: '/$portalId'
      fullPath: '/org/$org/idea-management/portals/$portalId'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/inbox/$feedbackId/': {
      id: '/(app)/org/$org/idea-management/inbox/$feedbackId/'
      path: '/$feedbackId'
      fullPath: '/org/$org/idea-management/inbox/$feedbackId'
      preLoaderRoute: typeof appOrgOrgIdeaManagementInboxFeedbackIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementInboxRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/view/': {
      id: '/(app)/org/$org/idea-management/ideas/view/'
      path: '/ideas/view'
      fullPath: '/org/$org/idea-management/ideas/view'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasViewIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/create/': {
      id: '/(app)/org/$org/idea-management/ideas/create/'
      path: '/ideas/create'
      fullPath: '/org/$org/idea-management/ideas/create'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasCreateIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/all/': {
      id: '/(app)/org/$org/idea-management/ideas/all/'
      path: '/ideas/all'
      fullPath: '/org/$org/idea-management/ideas/all'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasAllIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId'
      path: '/view/$viewId'
      fullPath: '/org/$org/roadmaps/$roadmapId/view/$viewId'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog'
      path: '/backlog'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute
    }
    '/(app)/org/$org/settings/user-management/users/$userId/': {
      id: '/(app)/org/$org/settings/user-management/users/$userId/'
      path: '/$userId'
      fullPath: '/org/$org/settings/user-management/users/$userId'
      preLoaderRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRoute
    }
    '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/': {
      id: '/(app)/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId/'
      path: '/holiday-scheme/$holidaySchemeId'
      fullPath: '/org/$org/settings/capacity/holiday-scheme/$holidaySchemeId'
      preLoaderRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRouteImport
      parentRoute: typeof appOrgOrgSettingsCapacityRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/'
      path: '/'
      fullPath: '/org/$org/roadmaps/$roadmapId/view/$viewId/'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute
    }
    '/(app)/org/$org/idea-management/portals/$portalId/$formId/': {
      id: '/(app)/org/$org/idea-management/portals/$portalId/$formId/'
      path: '/$portalId/$formId'
      fullPath: '/org/$org/idea-management/portals/$portalId/$formId'
      preLoaderRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementPortalsRouteRoute
    }
    '/(app)/org/$org/idea-management/ideas/view/$viewId/': {
      id: '/(app)/org/$org/idea-management/ideas/view/$viewId/'
      path: '/ideas/view/$viewId'
      fullPath: '/org/$org/idea-management/ideas/view/$viewId'
      preLoaderRoute: typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRouteImport
      parentRoute: typeof appOrgOrgIdeaManagementRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/'
      path: '/'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog/'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario'
      path: '/scenario'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog/scenario'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/timeline/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/timeline/'
      path: '/timeline'
      fullPath: '/org/$org/roadmaps/$roadmapId/view/$viewId/timeline'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/table/'
      path: '/table'
      fullPath: '/org/$org/roadmaps/$roadmapId/view/$viewId/table'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute
    }
    '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane/': {
      id: '/(app)/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane/'
      path: '/swimlane'
      fullPath: '/org/$org/roadmaps/$roadmapId/view/$viewId/swimlane'
      preLoaderRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRouteImport
      parentRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/'
      path: '/'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId'
      path: '/$scenarioId'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute
    }
    '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/': {
      id: '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/'
      path: '/'
      fullPath: '/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId/'
      preLoaderRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRouteImport
      parentRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute
    }
  }
}

interface appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteChildren {
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute
}

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteChildren: appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteChildren =
  {
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdIndexRoute,
  }

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteWithChildren =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute._addFileChildren(
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteChildren,
  )

interface appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteChildren {
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteWithChildren
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute
}

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteChildren: appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteChildren =
  {
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioScenarioIdRouteRouteWithChildren,
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioIndexRoute,
  }

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteWithChildren =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute._addFileChildren(
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteChildren,
  )

interface appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteChildren {
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteWithChildren
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute
}

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteChildren: appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteChildren =
  {
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogScenarioRouteRouteWithChildren,
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogIndexRoute,
  }

const appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteWithChildren =
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute._addFileChildren(
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteChildren,
  )

interface appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteChildren {
  appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteWithChildren
}

const appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteChildren: appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteChildren =
  {
    appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdBacklogRouteRouteWithChildren,
  }

const appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren =
  appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute._addFileChildren(
    appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteChildren,
  )

interface appOrgOrgAdaptivePlannerRouteRouteChildren {
  appOrgOrgAdaptivePlannerIndexRoute: typeof appOrgOrgAdaptivePlannerIndexRoute
  appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute: typeof appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren
}

const appOrgOrgAdaptivePlannerRouteRouteChildren: appOrgOrgAdaptivePlannerRouteRouteChildren =
  {
    appOrgOrgAdaptivePlannerIndexRoute: appOrgOrgAdaptivePlannerIndexRoute,
    appOrgOrgAdaptivePlannerPlanPlanIdRouteRoute:
      appOrgOrgAdaptivePlannerPlanPlanIdRouteRouteWithChildren,
  }

const appOrgOrgAdaptivePlannerRouteRouteWithChildren =
  appOrgOrgAdaptivePlannerRouteRoute._addFileChildren(
    appOrgOrgAdaptivePlannerRouteRouteChildren,
  )

interface appOrgOrgContributorsRouteRouteChildren {
  appOrgOrgContributorsIndexRoute: typeof appOrgOrgContributorsIndexRoute
  appOrgOrgContributorsContributorIdIndexRoute: typeof appOrgOrgContributorsContributorIdIndexRoute
}

const appOrgOrgContributorsRouteRouteChildren: appOrgOrgContributorsRouteRouteChildren =
  {
    appOrgOrgContributorsIndexRoute: appOrgOrgContributorsIndexRoute,
    appOrgOrgContributorsContributorIdIndexRoute:
      appOrgOrgContributorsContributorIdIndexRoute,
  }

const appOrgOrgContributorsRouteRouteWithChildren =
  appOrgOrgContributorsRouteRoute._addFileChildren(
    appOrgOrgContributorsRouteRouteChildren,
  )

interface appOrgOrgIdeaManagementInboxRouteRouteChildren {
  appOrgOrgIdeaManagementInboxIndexRoute: typeof appOrgOrgIdeaManagementInboxIndexRoute
  appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute: typeof appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute
}

const appOrgOrgIdeaManagementInboxRouteRouteChildren: appOrgOrgIdeaManagementInboxRouteRouteChildren =
  {
    appOrgOrgIdeaManagementInboxIndexRoute:
      appOrgOrgIdeaManagementInboxIndexRoute,
    appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute:
      appOrgOrgIdeaManagementInboxFeedbackIdIndexRoute,
  }

const appOrgOrgIdeaManagementInboxRouteRouteWithChildren =
  appOrgOrgIdeaManagementInboxRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementInboxRouteRouteChildren,
  )

interface appOrgOrgIdeaManagementPortalsRouteRouteChildren {
  appOrgOrgIdeaManagementPortalsIndexRoute: typeof appOrgOrgIdeaManagementPortalsIndexRoute
  appOrgOrgIdeaManagementPortalsPortalIdIndexRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdIndexRoute
  appOrgOrgIdeaManagementPortalsCreateIndexRoute: typeof appOrgOrgIdeaManagementPortalsCreateIndexRoute
  appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute: typeof appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute
}

const appOrgOrgIdeaManagementPortalsRouteRouteChildren: appOrgOrgIdeaManagementPortalsRouteRouteChildren =
  {
    appOrgOrgIdeaManagementPortalsIndexRoute:
      appOrgOrgIdeaManagementPortalsIndexRoute,
    appOrgOrgIdeaManagementPortalsPortalIdIndexRoute:
      appOrgOrgIdeaManagementPortalsPortalIdIndexRoute,
    appOrgOrgIdeaManagementPortalsCreateIndexRoute:
      appOrgOrgIdeaManagementPortalsCreateIndexRoute,
    appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute:
      appOrgOrgIdeaManagementPortalsPortalIdFormIdIndexRoute,
  }

const appOrgOrgIdeaManagementPortalsRouteRouteWithChildren =
  appOrgOrgIdeaManagementPortalsRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementPortalsRouteRouteChildren,
  )

interface appOrgOrgIdeaManagementRouteRouteChildren {
  appOrgOrgIdeaManagementInboxRouteRoute: typeof appOrgOrgIdeaManagementInboxRouteRouteWithChildren
  appOrgOrgIdeaManagementPortalsRouteRoute: typeof appOrgOrgIdeaManagementPortalsRouteRouteWithChildren
  appOrgOrgIdeaManagementCustomFieldsRoute: typeof appOrgOrgIdeaManagementCustomFieldsRoute
  appOrgOrgIdeaManagementOverviewRoute: typeof appOrgOrgIdeaManagementOverviewRoute
  appOrgOrgIdeaManagementPriorityFrameworksRoute: typeof appOrgOrgIdeaManagementPriorityFrameworksRoute
  appOrgOrgIdeaManagementIndexRoute: typeof appOrgOrgIdeaManagementIndexRoute
  appOrgOrgIdeaManagementCustomersIndexRoute: typeof appOrgOrgIdeaManagementCustomersIndexRoute
  appOrgOrgIdeaManagementIdeasIndexRoute: typeof appOrgOrgIdeaManagementIdeasIndexRoute
  appOrgOrgIdeaManagementProductAreasIndexRoute: typeof appOrgOrgIdeaManagementProductAreasIndexRoute
  appOrgOrgIdeaManagementIdeasAllIndexRoute: typeof appOrgOrgIdeaManagementIdeasAllIndexRoute
  appOrgOrgIdeaManagementIdeasCreateIndexRoute: typeof appOrgOrgIdeaManagementIdeasCreateIndexRoute
  appOrgOrgIdeaManagementIdeasViewIndexRoute: typeof appOrgOrgIdeaManagementIdeasViewIndexRoute
  appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute: typeof appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute
  appOrgOrgIdeaManagementProductAreasCreateIndexRoute: typeof appOrgOrgIdeaManagementProductAreasCreateIndexRoute
  appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute: typeof appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute
}

const appOrgOrgIdeaManagementRouteRouteChildren: appOrgOrgIdeaManagementRouteRouteChildren =
  {
    appOrgOrgIdeaManagementInboxRouteRoute:
      appOrgOrgIdeaManagementInboxRouteRouteWithChildren,
    appOrgOrgIdeaManagementPortalsRouteRoute:
      appOrgOrgIdeaManagementPortalsRouteRouteWithChildren,
    appOrgOrgIdeaManagementCustomFieldsRoute:
      appOrgOrgIdeaManagementCustomFieldsRoute,
    appOrgOrgIdeaManagementOverviewRoute: appOrgOrgIdeaManagementOverviewRoute,
    appOrgOrgIdeaManagementPriorityFrameworksRoute:
      appOrgOrgIdeaManagementPriorityFrameworksRoute,
    appOrgOrgIdeaManagementIndexRoute: appOrgOrgIdeaManagementIndexRoute,
    appOrgOrgIdeaManagementCustomersIndexRoute:
      appOrgOrgIdeaManagementCustomersIndexRoute,
    appOrgOrgIdeaManagementIdeasIndexRoute:
      appOrgOrgIdeaManagementIdeasIndexRoute,
    appOrgOrgIdeaManagementProductAreasIndexRoute:
      appOrgOrgIdeaManagementProductAreasIndexRoute,
    appOrgOrgIdeaManagementIdeasAllIndexRoute:
      appOrgOrgIdeaManagementIdeasAllIndexRoute,
    appOrgOrgIdeaManagementIdeasCreateIndexRoute:
      appOrgOrgIdeaManagementIdeasCreateIndexRoute,
    appOrgOrgIdeaManagementIdeasViewIndexRoute:
      appOrgOrgIdeaManagementIdeasViewIndexRoute,
    appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute:
      appOrgOrgIdeaManagementProductAreasProductAreaIdIndexRoute,
    appOrgOrgIdeaManagementProductAreasCreateIndexRoute:
      appOrgOrgIdeaManagementProductAreasCreateIndexRoute,
    appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute:
      appOrgOrgIdeaManagementIdeasViewViewIdIndexRoute,
  }

const appOrgOrgIdeaManagementRouteRouteWithChildren =
  appOrgOrgIdeaManagementRouteRoute._addFileChildren(
    appOrgOrgIdeaManagementRouteRouteChildren,
  )

interface appOrgOrgInsightsRouteRouteChildren {
  appOrgOrgInsightsIndexRoute: typeof appOrgOrgInsightsIndexRoute
  appOrgOrgInsightsInvestmentBalanceIndexRoute: typeof appOrgOrgInsightsInvestmentBalanceIndexRoute
  appOrgOrgInsightsProgressIndexRoute: typeof appOrgOrgInsightsProgressIndexRoute
}

const appOrgOrgInsightsRouteRouteChildren: appOrgOrgInsightsRouteRouteChildren =
  {
    appOrgOrgInsightsIndexRoute: appOrgOrgInsightsIndexRoute,
    appOrgOrgInsightsInvestmentBalanceIndexRoute:
      appOrgOrgInsightsInvestmentBalanceIndexRoute,
    appOrgOrgInsightsProgressIndexRoute: appOrgOrgInsightsProgressIndexRoute,
  }

const appOrgOrgInsightsRouteRouteWithChildren =
  appOrgOrgInsightsRouteRoute._addFileChildren(
    appOrgOrgInsightsRouteRouteChildren,
  )

interface appOrgOrgPortfolioRouteRouteChildren {
  appOrgOrgPortfolioIndexRoute: typeof appOrgOrgPortfolioIndexRoute
  appOrgOrgPortfolioTableIndexRoute: typeof appOrgOrgPortfolioTableIndexRoute
}

const appOrgOrgPortfolioRouteRouteChildren: appOrgOrgPortfolioRouteRouteChildren =
  {
    appOrgOrgPortfolioIndexRoute: appOrgOrgPortfolioIndexRoute,
    appOrgOrgPortfolioTableIndexRoute: appOrgOrgPortfolioTableIndexRoute,
  }

const appOrgOrgPortfolioRouteRouteWithChildren =
  appOrgOrgPortfolioRouteRoute._addFileChildren(
    appOrgOrgPortfolioRouteRouteChildren,
  )

interface appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteChildren {
  appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute
  appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute
  appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute
  appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute
}

const appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteChildren: appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteChildren =
  {
    appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute:
      appOrgOrgRoadmapsRoadmapIdViewViewIdIndexRoute,
    appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute:
      appOrgOrgRoadmapsRoadmapIdViewViewIdSwimlaneIndexRoute,
    appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute:
      appOrgOrgRoadmapsRoadmapIdViewViewIdTableIndexRoute,
    appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute:
      appOrgOrgRoadmapsRoadmapIdViewViewIdTimelineIndexRoute,
  }

const appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteWithChildren =
  appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute._addFileChildren(
    appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteChildren,
  )

interface appOrgOrgRoadmapsRoadmapIdRouteRouteChildren {
  appOrgOrgRoadmapsRoadmapIdIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdIndexRoute
  appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute: typeof appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteWithChildren
  appOrgOrgRoadmapsRoadmapIdViewIndexRoute: typeof appOrgOrgRoadmapsRoadmapIdViewIndexRoute
}

const appOrgOrgRoadmapsRoadmapIdRouteRouteChildren: appOrgOrgRoadmapsRoadmapIdRouteRouteChildren =
  {
    appOrgOrgRoadmapsRoadmapIdIndexRoute: appOrgOrgRoadmapsRoadmapIdIndexRoute,
    appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRoute:
      appOrgOrgRoadmapsRoadmapIdViewViewIdRouteRouteWithChildren,
    appOrgOrgRoadmapsRoadmapIdViewIndexRoute:
      appOrgOrgRoadmapsRoadmapIdViewIndexRoute,
  }

const appOrgOrgRoadmapsRoadmapIdRouteRouteWithChildren =
  appOrgOrgRoadmapsRoadmapIdRouteRoute._addFileChildren(
    appOrgOrgRoadmapsRoadmapIdRouteRouteChildren,
  )

interface appOrgOrgRoadmapsRouteRouteChildren {
  appOrgOrgRoadmapsRoadmapIdRouteRoute: typeof appOrgOrgRoadmapsRoadmapIdRouteRouteWithChildren
  appOrgOrgRoadmapsIndexRoute: typeof appOrgOrgRoadmapsIndexRoute
}

const appOrgOrgRoadmapsRouteRouteChildren: appOrgOrgRoadmapsRouteRouteChildren =
  {
    appOrgOrgRoadmapsRoadmapIdRouteRoute:
      appOrgOrgRoadmapsRoadmapIdRouteRouteWithChildren,
    appOrgOrgRoadmapsIndexRoute: appOrgOrgRoadmapsIndexRoute,
  }

const appOrgOrgRoadmapsRouteRouteWithChildren =
  appOrgOrgRoadmapsRouteRoute._addFileChildren(
    appOrgOrgRoadmapsRouteRouteChildren,
  )

interface appOrgOrgSettingsCapacityRouteRouteChildren {
  appOrgOrgSettingsCapacityIndexRoute: typeof appOrgOrgSettingsCapacityIndexRoute
  appOrgOrgSettingsCapacityHolidaySchemeIndexRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeIndexRoute
  appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute: typeof appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute
}

const appOrgOrgSettingsCapacityRouteRouteChildren: appOrgOrgSettingsCapacityRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityIndexRoute: appOrgOrgSettingsCapacityIndexRoute,
    appOrgOrgSettingsCapacityHolidaySchemeIndexRoute:
      appOrgOrgSettingsCapacityHolidaySchemeIndexRoute,
    appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute:
      appOrgOrgSettingsCapacityHolidaySchemeHolidaySchemeIdIndexRoute,
  }

const appOrgOrgSettingsCapacityRouteRouteWithChildren =
  appOrgOrgSettingsCapacityRouteRoute._addFileChildren(
    appOrgOrgSettingsCapacityRouteRouteChildren,
  )

interface appOrgOrgSettingsConnectionsRouteRouteChildren {
  appOrgOrgSettingsConnectionsIndexRoute: typeof appOrgOrgSettingsConnectionsIndexRoute
}

const appOrgOrgSettingsConnectionsRouteRouteChildren: appOrgOrgSettingsConnectionsRouteRouteChildren =
  {
    appOrgOrgSettingsConnectionsIndexRoute:
      appOrgOrgSettingsConnectionsIndexRoute,
  }

const appOrgOrgSettingsConnectionsRouteRouteWithChildren =
  appOrgOrgSettingsConnectionsRouteRoute._addFileChildren(
    appOrgOrgSettingsConnectionsRouteRouteChildren,
  )

interface appOrgOrgSettingsOrganizationRouteRouteChildren {
  appOrgOrgSettingsOrganizationIndexRoute: typeof appOrgOrgSettingsOrganizationIndexRoute
}

const appOrgOrgSettingsOrganizationRouteRouteChildren: appOrgOrgSettingsOrganizationRouteRouteChildren =
  {
    appOrgOrgSettingsOrganizationIndexRoute:
      appOrgOrgSettingsOrganizationIndexRoute,
  }

const appOrgOrgSettingsOrganizationRouteRouteWithChildren =
  appOrgOrgSettingsOrganizationRouteRoute._addFileChildren(
    appOrgOrgSettingsOrganizationRouteRouteChildren,
  )

interface appOrgOrgSettingsRolesRouteRouteChildren {
  appOrgOrgSettingsRolesIndexRoute: typeof appOrgOrgSettingsRolesIndexRoute
}

const appOrgOrgSettingsRolesRouteRouteChildren: appOrgOrgSettingsRolesRouteRouteChildren =
  {
    appOrgOrgSettingsRolesIndexRoute: appOrgOrgSettingsRolesIndexRoute,
  }

const appOrgOrgSettingsRolesRouteRouteWithChildren =
  appOrgOrgSettingsRolesRouteRoute._addFileChildren(
    appOrgOrgSettingsRolesRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementUsersRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersIndexRoute: typeof appOrgOrgSettingsUserManagementUsersIndexRoute
  appOrgOrgSettingsUserManagementUsersUserIdIndexRoute: typeof appOrgOrgSettingsUserManagementUsersUserIdIndexRoute
}

const appOrgOrgSettingsUserManagementUsersRouteRouteChildren: appOrgOrgSettingsUserManagementUsersRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersIndexRoute:
      appOrgOrgSettingsUserManagementUsersIndexRoute,
    appOrgOrgSettingsUserManagementUsersUserIdIndexRoute:
      appOrgOrgSettingsUserManagementUsersUserIdIndexRoute,
  }

const appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementUsersRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementUsersRouteRouteChildren,
  )

interface appOrgOrgSettingsUserManagementRouteRouteChildren {
  appOrgOrgSettingsUserManagementUsersRouteRoute: typeof appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren
  appOrgOrgSettingsUserManagementIndexRoute: typeof appOrgOrgSettingsUserManagementIndexRoute
  appOrgOrgSettingsUserManagementInvitesIndexRoute: typeof appOrgOrgSettingsUserManagementInvitesIndexRoute
}

const appOrgOrgSettingsUserManagementRouteRouteChildren: appOrgOrgSettingsUserManagementRouteRouteChildren =
  {
    appOrgOrgSettingsUserManagementUsersRouteRoute:
      appOrgOrgSettingsUserManagementUsersRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementIndexRoute:
      appOrgOrgSettingsUserManagementIndexRoute,
    appOrgOrgSettingsUserManagementInvitesIndexRoute:
      appOrgOrgSettingsUserManagementInvitesIndexRoute,
  }

const appOrgOrgSettingsUserManagementRouteRouteWithChildren =
  appOrgOrgSettingsUserManagementRouteRoute._addFileChildren(
    appOrgOrgSettingsUserManagementRouteRouteChildren,
  )

interface appOrgOrgSettingsRouteRouteChildren {
  appOrgOrgSettingsCapacityRouteRoute: typeof appOrgOrgSettingsCapacityRouteRouteWithChildren
  appOrgOrgSettingsConnectionsRouteRoute: typeof appOrgOrgSettingsConnectionsRouteRouteWithChildren
  appOrgOrgSettingsOrganizationRouteRoute: typeof appOrgOrgSettingsOrganizationRouteRouteWithChildren
  appOrgOrgSettingsRolesRouteRoute: typeof appOrgOrgSettingsRolesRouteRouteWithChildren
  appOrgOrgSettingsUserManagementRouteRoute: typeof appOrgOrgSettingsUserManagementRouteRouteWithChildren
  appOrgOrgSettingsIndexRoute: typeof appOrgOrgSettingsIndexRoute
  appOrgOrgSettingsBoxesIndexRoute: typeof appOrgOrgSettingsBoxesIndexRoute
  appOrgOrgSettingsCustomFieldsIndexRoute: typeof appOrgOrgSettingsCustomFieldsIndexRoute
  appOrgOrgSettingsCustomItemStatusIndexRoute: typeof appOrgOrgSettingsCustomItemStatusIndexRoute
  appOrgOrgSettingsEffortEstimationIndexRoute: typeof appOrgOrgSettingsEffortEstimationIndexRoute
  appOrgOrgSettingsIntegrationsIndexRoute: typeof appOrgOrgSettingsIntegrationsIndexRoute
  appOrgOrgSettingsItemTypesIndexRoute: typeof appOrgOrgSettingsItemTypesIndexRoute
  appOrgOrgSettingsLocationIndexRoute: typeof appOrgOrgSettingsLocationIndexRoute
  appOrgOrgSettingsSkillsIndexRoute: typeof appOrgOrgSettingsSkillsIndexRoute
  appOrgOrgSettingsSubscriptionsIndexRoute: typeof appOrgOrgSettingsSubscriptionsIndexRoute
  appOrgOrgSettingsBoxesBoxIdIndexRoute: typeof appOrgOrgSettingsBoxesBoxIdIndexRoute
}

const appOrgOrgSettingsRouteRouteChildren: appOrgOrgSettingsRouteRouteChildren =
  {
    appOrgOrgSettingsCapacityRouteRoute:
      appOrgOrgSettingsCapacityRouteRouteWithChildren,
    appOrgOrgSettingsConnectionsRouteRoute:
      appOrgOrgSettingsConnectionsRouteRouteWithChildren,
    appOrgOrgSettingsOrganizationRouteRoute:
      appOrgOrgSettingsOrganizationRouteRouteWithChildren,
    appOrgOrgSettingsRolesRouteRoute:
      appOrgOrgSettingsRolesRouteRouteWithChildren,
    appOrgOrgSettingsUserManagementRouteRoute:
      appOrgOrgSettingsUserManagementRouteRouteWithChildren,
    appOrgOrgSettingsIndexRoute: appOrgOrgSettingsIndexRoute,
    appOrgOrgSettingsBoxesIndexRoute: appOrgOrgSettingsBoxesIndexRoute,
    appOrgOrgSettingsCustomFieldsIndexRoute:
      appOrgOrgSettingsCustomFieldsIndexRoute,
    appOrgOrgSettingsCustomItemStatusIndexRoute:
      appOrgOrgSettingsCustomItemStatusIndexRoute,
    appOrgOrgSettingsEffortEstimationIndexRoute:
      appOrgOrgSettingsEffortEstimationIndexRoute,
    appOrgOrgSettingsIntegrationsIndexRoute:
      appOrgOrgSettingsIntegrationsIndexRoute,
    appOrgOrgSettingsItemTypesIndexRoute: appOrgOrgSettingsItemTypesIndexRoute,
    appOrgOrgSettingsLocationIndexRoute: appOrgOrgSettingsLocationIndexRoute,
    appOrgOrgSettingsSkillsIndexRoute: appOrgOrgSettingsSkillsIndexRoute,
    appOrgOrgSettingsSubscriptionsIndexRoute:
      appOrgOrgSettingsSubscriptionsIndexRoute,
    appOrgOrgSettingsBoxesBoxIdIndexRoute:
      appOrgOrgSettingsBoxesBoxIdIndexRoute,
  }

const appOrgOrgSettingsRouteRouteWithChildren =
  appOrgOrgSettingsRouteRoute._addFileChildren(
    appOrgOrgSettingsRouteRouteChildren,
  )

interface appOrgOrgTeamsTeamTeamIdRouteRouteChildren {
  appOrgOrgTeamsTeamTeamIdIndexRoute: typeof appOrgOrgTeamsTeamTeamIdIndexRoute
}

const appOrgOrgTeamsTeamTeamIdRouteRouteChildren: appOrgOrgTeamsTeamTeamIdRouteRouteChildren =
  {
    appOrgOrgTeamsTeamTeamIdIndexRoute: appOrgOrgTeamsTeamTeamIdIndexRoute,
  }

const appOrgOrgTeamsTeamTeamIdRouteRouteWithChildren =
  appOrgOrgTeamsTeamTeamIdRouteRoute._addFileChildren(
    appOrgOrgTeamsTeamTeamIdRouteRouteChildren,
  )

interface appOrgOrgTeamsRouteRouteChildren {
  appOrgOrgTeamsIndexRoute: typeof appOrgOrgTeamsIndexRoute
  appOrgOrgTeamsTeamTeamIdRouteRoute: typeof appOrgOrgTeamsTeamTeamIdRouteRouteWithChildren
  appOrgOrgTeamsMembersIndexRoute: typeof appOrgOrgTeamsMembersIndexRoute
}

const appOrgOrgTeamsRouteRouteChildren: appOrgOrgTeamsRouteRouteChildren = {
  appOrgOrgTeamsIndexRoute: appOrgOrgTeamsIndexRoute,
  appOrgOrgTeamsTeamTeamIdRouteRoute:
    appOrgOrgTeamsTeamTeamIdRouteRouteWithChildren,
  appOrgOrgTeamsMembersIndexRoute: appOrgOrgTeamsMembersIndexRoute,
}

const appOrgOrgTeamsRouteRouteWithChildren =
  appOrgOrgTeamsRouteRoute._addFileChildren(appOrgOrgTeamsRouteRouteChildren)

interface appOrgOrgRouteRouteChildren {
  appOrgOrgAdaptivePlannerRouteRoute: typeof appOrgOrgAdaptivePlannerRouteRouteWithChildren
  appOrgOrgContributorsRouteRoute: typeof appOrgOrgContributorsRouteRouteWithChildren
  appOrgOrgIdeaManagementRouteRoute: typeof appOrgOrgIdeaManagementRouteRouteWithChildren
  appOrgOrgInsightsRouteRoute: typeof appOrgOrgInsightsRouteRouteWithChildren
  appOrgOrgPortfolioRouteRoute: typeof appOrgOrgPortfolioRouteRouteWithChildren
  appOrgOrgRoadmapsRouteRoute: typeof appOrgOrgRoadmapsRouteRouteWithChildren
  appOrgOrgSettingsRouteRoute: typeof appOrgOrgSettingsRouteRouteWithChildren
  appOrgOrgTeamsRouteRoute: typeof appOrgOrgTeamsRouteRouteWithChildren
  appOrgOrgIndexRoute: typeof appOrgOrgIndexRoute
}

const appOrgOrgRouteRouteChildren: appOrgOrgRouteRouteChildren = {
  appOrgOrgAdaptivePlannerRouteRoute:
    appOrgOrgAdaptivePlannerRouteRouteWithChildren,
  appOrgOrgContributorsRouteRoute: appOrgOrgContributorsRouteRouteWithChildren,
  appOrgOrgIdeaManagementRouteRoute:
    appOrgOrgIdeaManagementRouteRouteWithChildren,
  appOrgOrgInsightsRouteRoute: appOrgOrgInsightsRouteRouteWithChildren,
  appOrgOrgPortfolioRouteRoute: appOrgOrgPortfolioRouteRouteWithChildren,
  appOrgOrgRoadmapsRouteRoute: appOrgOrgRoadmapsRouteRouteWithChildren,
  appOrgOrgSettingsRouteRoute: appOrgOrgSettingsRouteRouteWithChildren,
  appOrgOrgTeamsRouteRoute: appOrgOrgTeamsRouteRouteWithChildren,
  appOrgOrgIndexRoute: appOrgOrgIndexRoute,
}

const appOrgOrgRouteRouteWithChildren = appOrgOrgRouteRoute._addFileChildren(
  appOrgOrgRouteRouteChildren,
)

interface appRouteRouteChildren {
  appIndexRoute: typeof appIndexRoute
  appOrgOrgRouteRoute: typeof appOrgOrgRouteRouteWithChildren
  appInvitesIndexRoute: typeof appInvitesIndexRoute
  appOrgIndexRoute: typeof appOrgIndexRoute
  appProfileIndexRoute: typeof appProfileIndexRoute
  appIntegrationsJiraCallbackRoute: typeof appIntegrationsJiraCallbackRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appIndexRoute: appIndexRoute,
  appOrgOrgRouteRoute: appOrgOrgRouteRouteWithChildren,
  appInvitesIndexRoute: appInvitesIndexRoute,
  appOrgIndexRoute: appOrgIndexRoute,
  appProfileIndexRoute: appProfileIndexRoute,
  appIntegrationsJiraCallbackRoute: appIntegrationsJiraCallbackRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface unauthenticatedOrganizationsInvitesRouteRouteChildren {
  unauthenticatedOrganizationsInvitesAcceptRoute: typeof unauthenticatedOrganizationsInvitesAcceptRoute
  unauthenticatedOrganizationsInvitesErrorIndexRoute: typeof unauthenticatedOrganizationsInvitesErrorIndexRoute
}

const unauthenticatedOrganizationsInvitesRouteRouteChildren: unauthenticatedOrganizationsInvitesRouteRouteChildren =
  {
    unauthenticatedOrganizationsInvitesAcceptRoute:
      unauthenticatedOrganizationsInvitesAcceptRoute,
    unauthenticatedOrganizationsInvitesErrorIndexRoute:
      unauthenticatedOrganizationsInvitesErrorIndexRoute,
  }

const unauthenticatedOrganizationsInvitesRouteRouteWithChildren =
  unauthenticatedOrganizationsInvitesRouteRoute._addFileChildren(
    unauthenticatedOrganizationsInvitesRouteRouteChildren,
  )

interface unauthenticatedPublishedV1SwimlaneRouteRouteChildren {
  unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute
  unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute: typeof unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute
}

const unauthenticatedPublishedV1SwimlaneRouteRouteChildren: unauthenticatedPublishedV1SwimlaneRouteRouteChildren =
  {
    unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute:
      unauthenticatedPublishedV1SwimlaneLinkIdPngRouteRoute,
    unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute:
      unauthenticatedPublishedV1SwimlaneLinkIdIndexRoute,
  }

const unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren =
  unauthenticatedPublishedV1SwimlaneRouteRoute._addFileChildren(
    unauthenticatedPublishedV1SwimlaneRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  appRouteRoute: appRouteRouteWithChildren,
  unauthenticatedSignupRoute: unauthenticatedSignupRoute,
  unauthenticatedTermsRoute: unauthenticatedTermsRoute,
  unauthenticatedOrganizationsInvitesRouteRoute:
    unauthenticatedOrganizationsInvitesRouteRouteWithChildren,
  unauthenticatedLinkIdentityCallbackRoute:
    unauthenticatedLinkIdentityCallbackRoute,
  unauthenticatedOrganizationsStartRoute:
    unauthenticatedOrganizationsStartRoute,
  unauthenticatedLinkIdentityIndexRoute: unauthenticatedLinkIdentityIndexRoute,
  unauthenticatedOrganizationSelectorIndexRoute:
    unauthenticatedOrganizationSelectorIndexRoute,
  unauthenticatedPublishedV1SwimlaneRouteRoute:
    unauthenticatedPublishedV1SwimlaneRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
